const leaflets = {
    "apulia": {
        "config": {
            "primary-color": "#01538A",
            "secondary-color": "#E1001B",
            "tertiary-color": "#ffdd00",
            "hover-color": "rgba(220, 35, 17, 0.5)",
            "primary-alpha-color": "rgba(35, 94, 157, 0.7)",
            "clientIcon": require("assets/images/icona-Carrefour.png"),
            "serverPath": "carrefour-bariblu.volantinointerattivo.net/",
            "pdfPath": "/media/pdf/volantino.pdf",
            "shareFlyerTitle": "Volantino interattivo",
            "shareFlyerURL": "https://carrefour-bariblu.volantinointerattivo.net?v=438",
            "shareProductSentence": "Guarda questa fantastica offerta!",
            "ogTitleMeta": "Carrefour Bariblu | Volantino interattivo",
            "ogDescriptionMeta": "Dai uno sguardo al nostro nuovo volantino. Offerte valide dall'8 al 20 giugno",
            "ogImageMeta": "https://carrefour-bariblu.volantinointerattivo.net/media/images/bariblu_21_01_fb.png",
            "filterBrand": 0,
            "filterUnderprice": 0,
            "brandImage": "",
            "underPriceImage": "",
            "ga_active": true,
            "ga_tracking_id": "UA-152069090-56",
            "release_id": "1",
            "send_grocery_list_to_market": false,
            "grocery_list_min_value": 1,
            "client_id": 11,
            "signboard_id": 67,
            "has_pages": true,
            "hide_grocery_list": false,
            "hide_searchbar": false,
            "line_through": false,
            "category_banner": "",
            "category_banner_mobile": "",
            "hide_plus_product": false,
            "hide_plus_product_price": false,
            "product_banner": "",
            "href_banner": "",
            "internal_banner_click": false,
            "external_banner_click": false,
            "hide_listPages": false,
            "type": "leaflet",
            "version": 438
        },
        "leaflet": {
            "name": "carrefour 32 pp",
            "code": "438",
            "id_campaign": "438",
            "index": {
                "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/Indice-Carrefour-32_MJ4Dt8q.png",
                "links": [
                    {
                        "page": 2,
                        "blueprint": {
                            "top": 26.018567185278176,
                            "left": 6.212822109017041,
                            "width": 87.93480578375572,
                            "height": 7.407304239662946
                        }
                    },
                    {
                        "page": 6,
                        "blueprint": {
                            "top": 33.50746296723175,
                            "left": 5.920489578858823,
                            "width": 87.93480578375572,
                            "height": 7.407304239662946
                        }
                    },
                    {
                        "page": 12,
                        "blueprint": {
                            "top": 41.04778913146922,
                            "left": 5.651529388602523,
                            "width": 87.93480578375572,
                            "height": 7.407304239662946
                        }
                    },
                    {
                        "page": 17,
                        "blueprint": {
                            "top": 48.41221702368654,
                            "left": 5.73803431280427,
                            "width": 87.93480578375572,
                            "height": 7.407304239662946
                        }
                    },
                    {
                        "page": 22,
                        "blueprint": {
                            "top": 55.6737805350808,
                            "left": 5.631149379385026,
                            "width": 87.93480578375572,
                            "height": 7.407304239662946
                        }
                    },
                    {
                        "page": 26,
                        "blueprint": {
                            "top": 63.1493034050891,
                            "left": 5.9055908482782105,
                            "width": 87.93480578375572,
                            "height": 7.407304239662946
                        }
                    },
                    {
                        "page": 28,
                        "blueprint": {
                            "top": 70.57802469954416,
                            "left": 5.995577503042673,
                            "width": 87.93480578375572,
                            "height": 7.407304239662946
                        }
                    }
                ]
            },
            "categories": [
                {
                    "category_name": "Alimentari",
                    "subcategories": [
                        "Colazione",
                        "Dispensa",
                        "Snack Dolci",
                        "Pasta",
                        "Olio",
                        "Rossi",
                        "Snack Salati"
                    ]
                },
                {
                    "category_name": "Bevande",
                    "subcategories": [
                        "Acqua",
                        "Birre",
                        "Bibite",
                        "Succhi",
                        "Vini e Spumanti",
                        "Liquori"
                    ]
                },
                {
                    "category_name": "Surgelati",
                    "subcategories": [
                        "Gelati",
                        "Preparati",
                        "Carne",
                        "Panati",
                        "Ittico",
                        "Verdure"
                    ]
                },
                {
                    "category_name": "Macelleria",
                    "subcategories": [
                        "Suino",
                        "Altro",
                        "Bovino",
                        "Avicoli"
                    ]
                },
                {
                    "category_name": "Giardino e Giardinaggio",
                    "subcategories": [
                        "Barbecue e picnic",
                        "Altro"
                    ]
                },
                {
                    "category_name": "Self Service",
                    "subcategories": [
                        "Snack",
                        "Ittico",
                        "Latte",
                        "Salumi",
                        "Formaggi",
                        "Vegetali",
                        "Yogurt"
                    ]
                },
                {
                    "category_name": "Igiene Casa",
                    "subcategories": [
                        "Extra",
                        "Bucato",
                        "Stoviglie",
                        "Superfici",
                        "Pavimenti"
                    ]
                },
                {
                    "category_name": "Casa e Cucina",
                    "subcategories": [
                        "Altro",
                        "Stoviglie"
                    ]
                },
                {
                    "category_name": "Gastronomia",
                    "subcategories": [
                        "Salumi",
                        "Formaggi",
                        "Panetteria"
                    ]
                },
                {
                    "category_name": "Ortofrutta",
                    "subcategories": [
                        "Verdura",
                        "Frutta"
                    ]
                },
                {
                    "category_name": "Prima infanzia",
                    "subcategories": [
                        "Puericultura"
                    ]
                },
                {
                    "category_name": "Pet",
                    "subcategories": [
                        "Food",
                        "Care"
                    ]
                },
                {
                    "category_name": "Igiene Persona",
                    "subcategories": [
                        "Corpo",
                        "Intima",
                        "Capelli",
                        "Viso",
                        "Orale"
                    ]
                },
                {
                    "category_name": "Sport e Tempo Libero",
                    "subcategories": [
                        "Camping e Outdoor"
                    ]
                }
            ],
            "pages": [
                {
                    "number": 1,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_1_lItOmcT.jpg",
                    "products": [
                        {
                            "item_id": "cstm97241598",
                            "field1": "Divella",
                            "field2": "grottoli con gocce di cioccolato/ ottimini classici/",
                            "field3": "integrali/ riso e mais",
                            "field4": "gr.700",
                            "description": "Divella grottoli con gocce di cioccolato/ ottimini classici/ integrali/ riso e mais gr.700",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Grottoli con gocce di cioccolato",
                                "Ottimini classici",
                                "Integrali",
                                "Riso e mais"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 29.56625545844338,
                                "left": 3.666125954198478,
                                "width": 31.59904580152671,
                                "height": 30.0
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_p2OXBI5_GSNoJwu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Biscotti_Ottimini_Divella_-_Bont%C3%A0_senza_tempo.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm84990021",
                            "field1": "Sepinia",
                            "field2": "acqua minerale naturale oligominerale",
                            "field3": "lt.2x6",
                            "field4": "",
                            "description": "Sepinia acqua minerale naturale oligominerale lt.2x6",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 29.56625545844338,
                                "left": 35.26517175572519,
                                "width": 34.598473282442754,
                                "height": 30.0
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_idVrHvH_0aVWMoz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Sepina",
                                        "testo": "Acqua Sepinia nasce in Molise ed è imbottigliata a Sepino, in provincia di Campobasso. Contiene 4 mg di sodio per litro e ha un Residuo Fisso di 227 mg per litro, è quindi classificata come “oligominerale”. Si tratta di un’acqua indicata per chi deve seguire una dieta iposodica e per chi cerca un’acqua molto diuretica. Sepinia è commercializzata sia in versione piatta che effervescente, in bottiglie in PET di vari formati. (Fonte: bereacqua.org)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/images/download.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm73440029",
                            "field1": "Ichnusa",
                            "field2": "birra non filtra",
                            "field3": "cl.50",
                            "field4": "",
                            "description": "Ichnusa birra non filtra cl.50",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 29.56625545844338,
                                "left": 69.86364503816795,
                                "width": 26.708778625954196,
                                "height": 30.0
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_S8KUZN1_n9vWQbC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Ichnusa.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm61695004",
                            "field1": "Algida carte d'or",
                            "field2": "ocean classic",
                            "field3": "gelato vari gusti",
                            "field4": "gr.370/380/400",
                            "description": "Algida carte d'or ocean classic gelato vari gusti gr.370/380/400",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 59.566255458443365,
                                "left": 61.39513358778627,
                                "width": 35.17729007633587,
                                "height": 23.349491862555908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Hg3vU3s_HEx7YpJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.sharehappy.it/brands/carte-d-or/carte-dor-products/classici/carte-d'or-pistacchio.html"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm98235568",
                            "field1": "Capocollo di suino",
                            "field2": "senz'osso",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Capocollo di suino senz'osso l'etto",
                            "grammage": null,
                            "price": "0.50",
                            "price_label": "€ 0,50 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 59.566255458443365,
                                "left": 30.13635496183206,
                                "width": 31.2587786259542,
                                "height": 30.14167253950168
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_j5SjZy4_uGNCf2Q.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99264683",
                            "field1": "Barbecue elettrico 2000W",
                            "field2": "cm.46x28x70",
                            "field3": "",
                            "field4": "",
                            "description": "Barbecue elettrico 2000W cm.46x28x70",
                            "grammage": null,
                            "price": "27.99",
                            "price_label": "€ 27,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Barbecue e picnic",
                            "blueprint": {
                                "top": 59.07227868193823,
                                "left": 3.427576335877862,
                                "width": 26.708778625954196,
                                "height": 30.635649316006827
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_gf1X9NU_Q3nu0JC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 2,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_2_nDtd3Jk.jpg",
                    "products": [
                        {
                            "item_id": "cstm69737658",
                            "field1": "Carrefour",
                            "field2": "farina di grano duro",
                            "field3": "kg.1",
                            "field4": "",
                            "description": "Carrefour farina di grano duro kg.1",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.180624254918355,
                                "left": 3.189026717557251,
                                "width": 31.360496183206106,
                                "height": 21.744067338914178
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_4csoJMu_F4VvvrC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17244962",
                            "field1": "Carrefour",
                            "field2": "pane 8 cereali a fette",
                            "field3": "gr.400",
                            "field4": "",
                            "description": "Carrefour pane 8 cereali a fette gr.400",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.180624254918355,
                                "left": 34.54952290076336,
                                "width": 31.1395038167939,
                                "height": 21.744067338914178
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_kCb3Z39_hrX5d9Q.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm04894291",
                            "field1": "Carrefour",
                            "field2": "caffè gusto forte",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "Carrefour caffè gusto forte gr.250",
                            "grammage": null,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 9.180624254918355,
                                "left": 65.68902671755727,
                                "width": 31.00267175572519,
                                "height": 21.744067338914178
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_OrkpkIF_8LtCBbb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm89683600",
                            "field1": "Carrefour",
                            "field2": "acqua tonica",
                            "field3": "lt.1",
                            "field4": "",
                            "description": "Carrefour acqua tonica lt.1",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 30.92469159383253,
                                "left": 65.68902671755727,
                                "width": 31.00267175572519,
                                "height": 21.602394799412494
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_6ktsLS4_tf59irh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm09306172",
                            "field1": "Carrefour",
                            "field2": "biscotti petit",
                            "field3": "gr.500",
                            "field4": "",
                            "description": "Carrefour biscotti petit gr.500",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.92469159383253,
                                "left": 34.54952290076336,
                                "width": 31.1395038167939,
                                "height": 21.602394799412494
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_fj1icW0_kDHIebd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm76505735",
                            "field1": "Carrefour",
                            "field2": "pesto classico",
                            "field3": "gr.190",
                            "field4": "",
                            "description": "Carrefour pesto classico gr.190",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.92469159383253,
                                "left": 1.399904580152671,
                                "width": 33.149618320610685,
                                "height": 21.602394799412494
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Zjn3XRU_oNBZAMj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm53293464",
                            "field1": "Carrefour",
                            "field2": "succo nettare albicocca",
                            "field3": "ml.125x6",
                            "field4": "",
                            "description": "Carrefour succo nettare albicocca ml.125x6",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Succhi",
                            "blueprint": {
                                "top": 52.52708639324503,
                                "left": 1.399904580152671,
                                "width": 33.149618320610685,
                                "height": 21.25009056240903
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Xw8WVOb_Lyoz5sO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm82134060",
                            "field1": "Carrefour",
                            "field2": "panna cotta con caramello",
                            "field3": "gr.120x2",
                            "field4": "",
                            "description": "Carrefour panna cotta con caramello gr.120x2",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Snack",
                            "blueprint": {
                                "top": 52.52708639324503,
                                "left": 34.54952290076336,
                                "width": 31.020229007633596,
                                "height": 21.25009056240903
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_wNJIF3X_wsbDhrd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51031675",
                            "field1": "Carrefour",
                            "field2": "tiramisù",
                            "field3": "gr.90x2",
                            "field4": "",
                            "description": "Carrefour tiramisù gr.90x2",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Snack",
                            "blueprint": {
                                "top": 52.52708639324503,
                                "left": 65.56975190839697,
                                "width": 31.121946564885494,
                                "height": 21.25009056240903
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_As99tpL_BQYItlu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 3,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_3_hpHSTeM.jpg",
                    "products": [
                        {
                            "item_id": "cstm01170199",
                            "field1": "Carrefour",
                            "field2": "riso carnaroli",
                            "field3": "kg.1",
                            "field4": "",
                            "description": "Carrefour riso carnaroli kg.1",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.551106837297215,
                                "left": 3.4589694656488548,
                                "width": 31.121946564885494,
                                "height": 21.25009056240903
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_MrpfhnP_UVXufi3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Riso",
                                        "testo": "Il Riso Carnaroli nasce nel 1945 dall'incrocio di due varietà molto coltivate: il Vialone, dai chicchi quasi tondi ma ricchi di amilosio, quindi capaci di tenere la cottura ed il Lencino varietà dal chicco molto grande. La varietà così ottenuta riuscì a coniugare pregi e difetti dei suoi genitori: consistenza del Vialone (attenzione non l'odierno Vialone Nano) e le dimensioni del Lencino. A causa delle dimensioni tipiche del Lencino, il Carnaroli risulta una varietà sensibile alle problematiche di risaia e di conseguenza si riscontra scarsa produttività per ettaro. Queste caratteristiche contribuirono a minarne la coltivazione fino alla quasi scomparsa tra gli anni '70 ed '80. Agli inizi degli anni '80 però l'Ente Nazionale Risi, che conservava la varietà in purezza, iniziò tramite la ricerca un percorso che portò all'ottenimento di una varietà molto più facile da coltivare ma che conservava le stesse caratteristiche qualitative di prima. Iniziò cosi l'escalation del Carnaroli sia a livello nazionale che internazionale. Oggi è considerato un riso unico, inimitabile e una produzione di eccellenza grazie alle sue caratteristiche: straordinaria tenuta di cottura rispetto a quasi tutte le altre varietà, buonissima consistenza, ottima resa per ogni tipo di preparazione. Il Riso Carnaroli esalta le proprie qualità nella preparazione di risotti.",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/images/RISOCARNAROLICRF-8012666006540-1.webp"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm00055124",
                            "field1": "Carrefour",
                            "field2": "medaglione",
                            "field3": "vari gusti gr.90x2",
                            "field4": "",
                            "description": "Carrefour medaglione vari gusti gr.90x2",
                            "grammage": null,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.551106837297215,
                                "left": 34.58091603053435,
                                "width": 30.90095419847329,
                                "height": 21.25009056240903
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_hwcaS01_Kxz6pjQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm92333160",
                            "field1": "Carrefour",
                            "field2": "pasta frolla fresca",
                            "field3": "gr.230",
                            "field4": "",
                            "description": "Carrefour pasta frolla fresca gr.230",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.551106837297215,
                                "left": 65.48187022900763,
                                "width": 32.07614503816794,
                                "height": 21.25009056240903
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_vYnlICG_TL3i9eF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm09155802",
                            "field1": "Carrefour",
                            "field2": "bastoncini di pesce",
                            "field3": "panati surgelati x18",
                            "field4": "gr.450",
                            "description": "Carrefour bastoncini di pesce panati surgelati x18 gr.450",
                            "grammage": null,
                            "price": "2.79",
                            "price_label": "€ 2,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 30.801197399706243,
                                "left": 65.48187022900763,
                                "width": 32.07614503816794,
                                "height": 21.478900605286206
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_KXzC1w4_SfETKUW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm84302153",
                            "field1": "Carrefour",
                            "field2": "pizza margherita surgelata x2",
                            "field3": "gr.660",
                            "field4": "",
                            "description": "Carrefour pizza margherita surgelata x2 gr.660",
                            "grammage": null,
                            "price": "3.69",
                            "price_label": "€ 3,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 30.801197399706243,
                                "left": 34.58091603053434,
                                "width": 30.90095419847329,
                                "height": 21.478900605286206
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_LZtDXV7_LL77M9K.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "title": "",
                                    "data": {
                                        "specifiche": "Farina di frumento, Mozzarella 18.2%, Acqua, Passata di pomodoro 12.2%, Olio di semi di girasole, Polpa di pomodoro 2.0%, Sale, Olio di oliva, Destrosio, Origano disidratato, Lievito, Può contenere tracce di soia pesce e crostacei",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/images/PIZZAMARGHERITACRF2X330GR-8012666054077-1.webp"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm45719576",
                            "field1": "Carrefour",
                            "field2": "patate fritte",
                            "field3": "kg.1",
                            "field4": "",
                            "description": "Carrefour patate fritte kg.1",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 30.801197399706243,
                                "left": 3.578244274809155,
                                "width": 31.00267175572519,
                                "height": 21.478900605286206
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_te4fChe_UyTLd4l.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm73566034",
                            "field1": "Carrefour",
                            "field2": "lavastoviglie limone",
                            "field3": "x40 cabs",
                            "field4": "",
                            "description": "Carrefour lavastoviglie limone x40 cabs",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 52.280098004992446,
                                "left": 3.578244274809155,
                                "width": 31.00267175572519,
                                "height": 21.373584756535315
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_rMupidp_moxzGme.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm08709731",
                            "field1": "Carrefour",
                            "field2": "asciugatutto 2 rotoli",
                            "field3": "",
                            "field4": "",
                            "description": "Carrefour asciugatutto 2 rotoli",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 52.280098004992446,
                                "left": 34.58091603053434,
                                "width": 31.1395038167939,
                                "height": 21.373584756535315
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_TaAtNB0_uznliA0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm85185754",
                            "field1": "Carrefour",
                            "field2": "vaschette alluminio caldo gelo",
                            "field3": "varie porzioni",
                            "field4": "",
                            "description": "Carrefour vaschette alluminio caldo gelo varie porzioni",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 52.280098004992446,
                                "left": 65.72041984732826,
                                "width": 31.00267175572519,
                                "height": 21.373584756535315
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_92CzfRC_l9FQfNs.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 4,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_4_vCB2A7z.jpg",
                    "products": [
                        {
                            "item_id": "cstm87413502",
                            "field1": "speck cotto",
                            "field2": "l'etto",
                            "field3": "",
                            "field4": "",
                            "description": "speck cotto l'etto",
                            "grammage": null,
                            "price": "1.09",
                            "price_label": "€ 1,09 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 8.926988791666938,
                                "left": 3.6509273616412217,
                                "width": 46.278625954198475,
                                "height": 21.73497816622648
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_WyeV3bX_bIAo98y.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm90471670",
                            "field1": "Parmacotto",
                            "field2": "prosciutto cotto",
                            "field3": "azzurro alta qualità",
                            "field4": "l'etto",
                            "description": "Parmacotto prosciutto cotto azzurro alta qualità l'etto",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 8.926988791666938,
                                "left": 49.92955331583969,
                                "width": 23.85496183206107,
                                "height": 21.73497816622648
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_cOavmtr_Y4Z4Qsk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm41586240",
                            "field1": "Palmieri",
                            "field2": "mortadella favola",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Palmieri mortadella favola l'etto",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 8.926988791666938,
                                "left": 73.78451514790078,
                                "width": 23.02003816793893,
                                "height": 21.73497816622648
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_vV1xACq_mJRjC1c.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm01054770",
                            "field1": "Arborea",
                            "field2": "mozzarella fiordilatte",
                            "field3": "gr.100x3",
                            "field4": "",
                            "description": "Arborea mozzarella fiordilatte gr.100x3",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 30.661966957893416,
                                "left": 73.78451514790078,
                                "width": 23.02003816793893,
                                "height": 43.222967944200384
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_UzzeRw5_XbR6uNd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88253317",
                            "field1": "Cavazzuti",
                            "field2": "salame contadino dolce",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Cavazzuti salame contadino dolce l'etto",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 30.661966957893416,
                                "left": 50.048828125,
                                "width": 23.73568702290077,
                                "height": 22.10546074860534
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_j2I3KZ1_uazIXXX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm58095479",
                            "field1": "Manzo affumicato",
                            "field2": "l'etto",
                            "field3": "",
                            "field4": "",
                            "description": "Manzo affumicato l'etto",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 30.661966957893416,
                                "left": 26.313141102099237,
                                "width": 23.735687022900763,
                                "height": 22.10546074860534
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_tvAhrwX_HDK9rjC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm79601367",
                            "field1": "Prosciutto crudo nazionale",
                            "field2": "l'etto",
                            "field3": "",
                            "field4": "",
                            "description": "Prosciutto crudo nazionale l'etto",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 30.661966957893416,
                                "left": 1.2654311784351144,
                                "width": 25.047709923664126,
                                "height": 22.10546074860534
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_k5fkyxT_H5OB8qA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm66772411",
                            "field1": "Clai",
                            "field2": "salame napoli",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Clai salame napoli l'etto",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 52.76742770649875,
                                "left": 1.2654311784351144,
                                "width": 25.047709923664126,
                                "height": 20.87051880734247
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_YdGbPdd_YmCQHXR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm74815931",
                            "field1": "Clai",
                            "field2": "salame golosetto",
                            "field3": "gr.100",
                            "field4": "",
                            "description": "Clai salame golosetto gr.100",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 52.76742770649875,
                                "left": 26.313141102099237,
                                "width": 23.61641221374046,
                                "height": 20.87051880734247
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ab0y6RY_Ku23EBh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm44207074",
                            "field1": "Pancetta coppata magrissima",
                            "field2": "l'etto",
                            "field3": "",
                            "field4": "",
                            "description": "Pancetta coppata magrissima l'etto",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 52.76742770649875,
                                "left": 49.92955331583969,
                                "width": 23.735687022900763,
                                "height": 20.87051880734247
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_EtcY8xa_EM8uWrR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm89925655",
                            "field1": "Fiorucci",
                            "field2": "quanto basta",
                            "field3": "mortadella preaffettata",
                            "field4": "gr.85",
                            "description": "Fiorucci quanto basta mortadella preaffettata gr.85",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 73.63794651384121,
                                "left": 73.66524033874046,
                                "width": 22.90076335877863,
                                "height": 21.981966554479055
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_arYhvlj_aqOWBwz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17046958",
                            "field1": "Fiorucci",
                            "field2": "quanto basta",
                            "field3": "petto di tacchino/ salame di milano",
                            "field4": "preaffettato gr.90",
                            "description": "Fiorucci quanto basta petto di tacchino/ salame di milano preaffettato gr.90",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Petto di tacchina",
                                "Salame di milano"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 73.63794651384121,
                                "left": 49.810278506679396,
                                "width": 23.85496183206107,
                                "height": 21.981966554479055
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_t8IOusu_gCKGtL4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm01811382",
                            "field1": "Fiorucci",
                            "field2": "quanto basta",
                            "field3": "prosciutto cotto preaffettato",
                            "field4": "gr.90",
                            "description": "Fiorucci quanto basta prosciutto cotto preaffettato gr.90",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 73.63794651384121,
                                "left": 26.19386629293893,
                                "width": 23.61641221374046,
                                "height": 21.981966554479055
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_JtSehCM_gPZZ9v0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm23591835",
                            "field1": "Fiorucci",
                            "field2": "quanto basta",
                            "field3": "prosciutto crudo preaffettato",
                            "field4": "gr.85",
                            "description": "Fiorucci quanto basta prosciutto crudo preaffettato gr.85",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 73.63794651384121,
                                "left": 2.100354842557252,
                                "width": 24.093511450381676,
                                "height": 21.981966554479055
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_uKbMuCc_XoTMU9k.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 5,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_5_NcJilF4.jpg",
                    "products": [
                        {
                            "item_id": "cstm59865804",
                            "field1": "Parmiggiano regiano",
                            "field2": "stagionato 25 mesi D.O.P.",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Parmiggiano regiano stagionato 25 mesi D.O.P. l'etto",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 8.926988791666938,
                                "left": 3.412377743320611,
                                "width": 46.636450381679396,
                                "height": 21.73497816622648
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_uZinwEU_NHXMwgO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm54943493",
                            "field1": "Salsiccia",
                            "field2": "dolce/ piccante",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Salsiccia dolce/ piccante l'etto",
                            "grammage": null,
                            "price": "1.09",
                            "price_label": "€ 1,09 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [
                                "Dolce",
                                "Piccante"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 8.926988791666938,
                                "left": 50.048828125,
                                "width": 23.73568702290076,
                                "height": 21.73497816622648
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_c2voT5m_3kpQUVa.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm48274401",
                            "field1": "Aia",
                            "field2": "tarky fesa di tacchino arrosto",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Aia tarky fesa di tacchino arrosto l'etto",
                            "grammage": null,
                            "price": "1.19",
                            "price_label": "€ 1,19 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 8.926988791666938,
                                "left": 73.78451514790078,
                                "width": 24.332061068702295,
                                "height": 21.73497816622648
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_lWK7qxy_bqmo6vY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm66841186",
                            "field1": "Formaggio fresco",
                            "field2": "breganze",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Formaggio fresco breganze l'etto",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 30.661966957893416,
                                "left": 73.78451514790078,
                                "width": 24.332061068702295,
                                "height": 21.73497816622648
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_0HAaZio_Je5Etcm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm21417485",
                            "field1": "Marte",
                            "field2": "ricotta marzolina",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Marte ricotta marzolina l'etto",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 30.661966957893416,
                                "left": 49.92955331583969,
                                "width": 23.854961832061065,
                                "height": 21.73497816622648
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_NyZgYvg_abKt7iZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm64714857",
                            "field1": "Valgrana",
                            "field2": "formaggio piemontino",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Valgrana formaggio piemontino l'etto",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 30.661966957893416,
                                "left": 26.313141102099237,
                                "width": 23.616412213740464,
                                "height": 21.73497816622648
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_BauSQhy_nQJMa1g.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm48153948",
                            "field1": "Sanguedolce",
                            "field2": "gustosè scamorza",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Sanguedolce gustosè scamorza l'etto",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 30.661966957893416,
                                "left": 2.4581792700381735,
                                "width": 23.854961832061065,
                                "height": 21.73497816622648
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_2TUPIkx_hblnwcS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm39771617",
                            "field1": "Auricchio",
                            "field2": "mini provolette",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Auricchio mini provolette l'etto",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 52.39694512411989,
                                "left": 2.4581792700381735,
                                "width": 23.854961832061065,
                                "height": 21.36449558384762
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_8dcubXp_a7CGjzs.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Auricchio",
                                        "testo": "Ingrediente perfetto per tanti primi e secondi piatti della tradizione. Alcuni esempi? Impanato alla milanese, grigliato alla piastra, a cubetti nelle insalate miste o in numerosi antipasti sfiziosi.\n\nPer la forma caratteristica, scolpita e rifinita a mano, Auricchio Giovane viene anche utilizzato come originale regalo in particolari ricorrenze, oltre che in occasione della Pasqua e del Natale. Scopri tutti i suggerimenti Auricchio nel nostro pratico ricettario: per una pausa pranzo unica mettiti alla prova con la Millefoglie di melanzane su cannoli ripieni. (Fonte: auricchio.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/images/download_1.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm32190271",
                            "field1": "Leerdammer",
                            "field2": "l'etto",
                            "field3": "",
                            "field4": "",
                            "description": "Leerdammer l'etto",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 52.39694512411989,
                                "left": 26.313141102099237,
                                "width": 23.616412213740464,
                                "height": 21.36449558384762
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_40KX9Cr_8KkaiYF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Panino_Corner_-_VEGGIE_BURGER.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm47824087",
                            "field1": "Formaggio",
                            "field2": "prataiola con rucola",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Formaggio prataiola con rucola l'etto",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 52.39694512411989,
                                "left": 49.92955331583969,
                                "width": 46.51717557251908,
                                "height": 42.975979555947816
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_yNoso7K_wj6tYP2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm59494610",
                            "field1": "Carozzi",
                            "field2": "gorgonzola D.O.P",
                            "field3": "gr.200",
                            "field4": "",
                            "description": "Carozzi gorgonzola D.O.P gr.200",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 73.76144070796751,
                                "left": 26.313141102099237,
                                "width": 23.616412213740464,
                                "height": 21.611483972100192
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_oRCvoqZ_4Tv4oJy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm46107480",
                            "field1": "Carozzi",
                            "field2": "taleggio classico D.O.P.",
                            "field3": "l'etto",
                            "field4": "",
                            "description": "Carozzi taleggio classico D.O.P. l'etto",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00 l'etto",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 73.76144070796751,
                                "left": 1.9810800333969518,
                                "width": 24.332061068702288,
                                "height": 21.611483972100192
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_rNPAsWu_z9XE031.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 6,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_6_YGoUPdP.jpg",
                    "products": [
                        {
                            "item_id": "cstm53258638",
                            "field1": "Tritato scelto di bovino",
                            "field2": "adulto scottona",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Tritato scelto di bovino adulto scottona al kg",
                            "grammage": null,
                            "price": "7.90",
                            "price_label": "€ 7,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 9.173977179919513,
                                "left": 3.5316525524809164,
                                "width": 61.90362595419847,
                                "height": 43.222967944200384
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_M4bguKQ_HscfUdu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm11674588",
                            "field1": "Bocconcini di bovino",
                            "field2": "adulto scottona",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Bocconcini di bovino adulto scottona al kg",
                            "grammage": null,
                            "price": "7.49",
                            "price_label": "€ 7,49 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 9.173977179919513,
                                "left": 65.4352785066794,
                                "width": 31.011450381679392,
                                "height": 21.611483972100192
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_fMnO4O0_grzkoVl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm66669332",
                            "field1": "Straccetti",
                            "field2": "di bovino adulto scottona",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Straccetti di bovino adulto scottona al kg",
                            "grammage": null,
                            "price": "12.90",
                            "price_label": "€ 12,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 30.785461152019703,
                                "left": 65.4352785066794,
                                "width": 31.011450381679392,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_oUSwfqN_MfA1OYc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm61055951",
                            "field1": "Torta di carne",
                            "field2": "di bovino adulto tricolore",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Torta di carne di bovino adulto tricolore al kg",
                            "grammage": null,
                            "price": "11.90",
                            "price_label": "€ 11,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 52.2734509299936,
                                "left": 65.4352785066794,
                                "width": 31.011450381679392,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_5uVnMhL_1OwyLYM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm70272737",
                            "field1": "Trippa fresca",
                            "field2": "di bovino adulto",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Trippa fresca di bovino adulto al kg",
                            "grammage": null,
                            "price": "5.90",
                            "price_label": "€ 5,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 52.2734509299936,
                                "left": 34.54310293416031,
                                "width": 30.892175572519083,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_4WJaIFz_xyagmyx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51274243",
                            "field1": "Spezzatino",
                            "field2": "di bovino adulto con osso",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Spezzatino di bovino adulto con osso al kg",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 52.2734509299936,
                                "left": 2.2196296517175576,
                                "width": 32.32347328244275,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_KInM1Z2_CsJWVES.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm06229380",
                            "field1": "Tramezzino classico",
                            "field2": "di bovino adulto",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Tramezzino classico di bovino adulto al kg",
                            "grammage": null,
                            "price": "9.90",
                            "price_label": "€ 9,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 73.76144070796751,
                                "left": 2.2196296517175576,
                                "width": 32.32347328244275,
                                "height": 21.981966554479055
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_hmMf8tr_nTlWZun.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51980369",
                            "field1": "Fettine primo taglio",
                            "field2": "di bovino adulto",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Fettine primo taglio di bovino adulto al kg",
                            "grammage": null,
                            "price": "10.90",
                            "price_label": "€ 10,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 73.76144070796751,
                                "left": 34.54310293416031,
                                "width": 61.90362595419847,
                                "height": 21.981966554479055
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_jbr42rE_2Evhe8F.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 7,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_7_yY3s1Gd.jpg",
                    "products": [
                        {
                            "item_id": "cstm99595555",
                            "field1": "Lonza di suino",
                            "field2": "al barbecure",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Lonza di suino al barbecure al kg",
                            "grammage": null,
                            "price": "7.90",
                            "price_label": "€ 7,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 9.173977179919513,
                                "left": 0.0,
                                "width": 34.54310293416031,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_qkb5uiv_rP2Yhpg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm97124567",
                            "field1": "Pancetta di suino ripiena",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Pancetta di suino ripiena al kg",
                            "grammage": null,
                            "price": "6.90",
                            "price_label": "€ 6,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 30.661966957893416,
                                "left": 0.0,
                                "width": 34.54310293416031,
                                "height": 21.611483972100192
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_DkalIO3_uH4T6vu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm39991487",
                            "field1": "Lonza di suino",
                            "field2": "a fette",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Lonza di suino a fette al kg",
                            "grammage": null,
                            "price": "5.89",
                            "price_label": "€ 5,89 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 8.926988791666938,
                                "left": 34.54310293416031,
                                "width": 62.117202409351144,
                                "height": 43.34646213832667
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_rXLuxqb_b3pWf2g.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm45996863",
                            "field1": "Maggi",
                            "field2": "il saccoccio",
                            "field3": "vari aromi",
                            "field4": "gr.30/32/34",
                            "description": "Maggi il saccoccio vari aromi gr.30/32/34",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.2734509299936,
                                "left": 65.673828125,
                                "width": 30.98647721851145,
                                "height": 22.352449136857913
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_e5UEUu8_glVEwHg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm12417738",
                            "field1": "Cereal",
                            "field2": "novosal",
                            "field3": "gr.200",
                            "field4": "",
                            "description": "Cereal novosal gr.200",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.2734509299936,
                                "left": 34.63740458015267,
                                "width": 31.03642354484733,
                                "height": 22.352449136857913
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_58LELv9_lz4B4iF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm82083288",
                            "field1": "Ponti",
                            "field2": "glassa gastronomica",
                            "field3": "vari tipi e grammature",
                            "field4": "",
                            "description": "Ponti glassa gastronomica vari tipi e grammature",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 74.62590006685151,
                                "left": 34.63740458015267,
                                "width": 31.03642354484733,
                                "height": 20.99401300146876
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_AxY5NiV_8jBVU9m.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Glassa_Gastronomica_Ponti_all_Aceto_Balsamico_di_Modena_I.G.P.__-_Spot__FgUp3EY.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm39275902",
                            "field1": "Drogheria & alimentari",
                            "field2": "spezie classiche",
                            "field3": "vari tipi e grammature",
                            "field4": "",
                            "description": "Drogheria & alimentari spezie classiche vari tipi e grammature",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 74.62590006685151,
                                "left": 65.673828125,
                                "width": 30.98647721851145,
                                "height": 20.99401300146876
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_6zBGv40_8Za7EFx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.drogheria.com/prodotti/insaporitori-e-condimenti/sapori-creativi/pepe-rosa-limone"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm25146863",
                            "field1": "Tritato misto",
                            "field2": "bovino e suino conf. famiglia",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Tritato misto bovino e suino conf. famiglia al kg",
                            "grammage": null,
                            "price": "5.90",
                            "price_label": "€ 5,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 52.76742770649875,
                                "left": 3.173828125,
                                "width": 30.98647721851145,
                                "height": 23.34040268986821
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_m7pIPmZ_6m0w5ju.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm11253469",
                            "field1": "Tritato di suino",
                            "field2": "conf. famiglia",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Tritato di suino conf. famiglia al kg",
                            "grammage": null,
                            "price": "4.59",
                            "price_label": "€ 4,59 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 76.10783039636696,
                                "left": 3.173828125,
                                "width": 30.98647721851145,
                                "height": 19.265094283700744
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_znHt76H_4Q83OX7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 8,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_8_LJWAhDA.jpg",
                    "products": [
                        {
                            "item_id": "cstm81320973",
                            "field1": "Coniglio intero",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Coniglio intero al kg",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 8.926988791666938,
                                "left": 3.5316525524809164,
                                "width": 62.022900763358784,
                                "height": 21.858472360352764
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_1nEW1IX_rjqyIAh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm49403273",
                            "field1": "Bocconcini di petto di pollo",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Bocconcini di petto di pollo al kg",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 8.926988791666938,
                                "left": 65.5545533158397,
                                "width": 31.369274809160306,
                                "height": 21.858472360352764
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_b3RNmWV_fxeTsNc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm49700943",
                            "field1": "Aia",
                            "field2": "keb's kebab di pollo",
                            "field3": "gr.350 al pz",
                            "field4": "",
                            "description": "Aia keb's kebab di pollo gr.350 al pz",
                            "grammage": null,
                            "price": "2.79",
                            "price_label": "€ 2,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Carne",
                            "blueprint": {
                                "top": 33.00835664629287,
                                "left": 65.3160036975191,
                                "width": 31.369274809160306,
                                "height": 21.858472360352764
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_EOi3pZM_Bco4pmH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm53794835",
                            "field1": "Aia",
                            "field2": "spinacine già cotte",
                            "field3": "gr.440 al pz",
                            "field4": "",
                            "description": "Aia spinacine già cotte gr.440 al pz",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Panati",
                            "blueprint": {
                                "top": 33.00835664629287,
                                "left": 36.451499880725194,
                                "width": 28.864503816793896,
                                "height": 21.858472360352764
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_dpqjl5R_WZHfeja.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm19379695",
                            "field1": "Aia",
                            "field2": "cordon bleu",
                            "field3": "di tacchino già cotti",
                            "field4": "gr.245 al pz",
                            "description": "Aia cordon bleu di tacchino già cotti gr.245 al pz",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Panati",
                            "blueprint": {
                                "top": 33.00835664629287,
                                "left": 3.770202170801527,
                                "width": 32.68129770992366,
                                "height": 21.858472360352764
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_nB614Y1_a31rqic.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm02665075",
                            "field1": "Amadori",
                            "field2": "birbe filetti di",
                            "field3": "pollo impanati",
                            "field4": "gr.300 al pz",
                            "description": "Amadori birbe filetti di pollo impanati gr.300 al pz",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Panati",
                            "blueprint": {
                                "top": 54.86682900664563,
                                "left": 3.770202170801527,
                                "width": 32.68129770992366,
                                "height": 19.01810589544817
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_QilXMWJ_X49BlLW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99022840",
                            "field1": "Martini",
                            "field2": "hamburger di pollo",
                            "field3": "gr.200 al pz",
                            "field4": "",
                            "description": "Martini hamburger di pollo gr.200 al pz",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Carne",
                            "blueprint": {
                                "top": 54.86682900664563,
                                "left": 36.451499880725194,
                                "width": 30.77290076335878,
                                "height": 19.01810589544817
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_SUooBjl_lI1wa9Q.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm54485399",
                            "field1": "Martini",
                            "field2": "mini filetti di pollo panati",
                            "field3": "gr.300 al pz",
                            "field4": "",
                            "description": "Martini mini filetti di pollo panati gr.300 al pz",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Panati",
                            "blueprint": {
                                "top": 54.86682900664563,
                                "left": 67.22440064408397,
                                "width": 29.34160305343512,
                                "height": 19.01810589544817
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_4xxyAnj_8AEfjDx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm40923146",
                            "field1": "Forno della rotonda",
                            "field2": "schiocco di pane sfogliato",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Forno della rotonda schiocco di pane sfogliato al kg",
                            "grammage": null,
                            "price": "4.79",
                            "price_label": "€ 4,79 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Panetteria",
                            "blueprint": {
                                "top": 76.10783039636696,
                                "left": 74.6194388120229,
                                "width": 21.946564885496183,
                                "height": 19.141600089574457
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_60tJM5J_oOz907O.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm22342619",
                            "field1": "Forno della rotonda",
                            "field2": "ciabatta patata di grano tenero",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Forno della rotonda ciabatta patata di grano tenero al kg",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Panetteria",
                            "blueprint": {
                                "top": 76.10783039636696,
                                "left": 50.764476979961835,
                                "width": 23.85496183206107,
                                "height": 19.141600089574457
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_iyazjOg_oALQkwM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm20870488",
                            "field1": "Forno della rotonda",
                            "field2": "baguette di grano tenero",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Forno della rotonda baguette di grano tenero al kg",
                            "grammage": null,
                            "price": "2.79",
                            "price_label": "€ 2,79 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Panetteria",
                            "blueprint": {
                                "top": 76.10783039636696,
                                "left": 25.716767056297712,
                                "width": 25.047709923664126,
                                "height": 19.141600089574457
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_L12LoCU_MX3ABS0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm66469788",
                            "field1": "Forno della rotonda",
                            "field2": "demi con mix di semi di grano",
                            "field3": "tenero al kg",
                            "field4": "",
                            "description": "Forno della rotonda demi con mix di semi di grano tenero al kg",
                            "grammage": null,
                            "price": "4.29",
                            "price_label": "€ 4,29 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Panetteria",
                            "blueprint": {
                                "top": 74.50240587272523,
                                "left": 3.5316525524809164,
                                "width": 22.1851145038168,
                                "height": 20.747024613216183
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_cfdHvUD_wapyKsV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 9,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_9_3zCF7rY.jpg",
                    "products": [
                        {
                            "item_id": "cstm96196614",
                            "field1": "Salsiccia di suino alla primavera",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Salsiccia di suino alla primavera al kg",
                            "grammage": null,
                            "price": "6.90",
                            "price_label": "€ 6,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 23.128821116189926,
                                "left": 3.412377743320611,
                                "width": 22.423664122137406,
                                "height": 21.36449558384762
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_mequguu_UDACApI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm19025893",
                            "field1": "Pancetta di suino",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Pancetta di suino al kg",
                            "grammage": null,
                            "price": "4.90",
                            "price_label": "€ 4,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 23.128821116189926,
                                "left": 25.836041865458014,
                                "width": 22.423664122137406,
                                "height": 21.36449558384762
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_54RUF59_LRn9QrD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm54500155",
                            "field1": "Salsiccia gustoso di suino",
                            "field2": "dolce/ piccante",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Salsiccia gustoso di suino dolce/ piccante al kg",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [
                                "Piccante",
                                "Dolce"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 23.128821116189926,
                                "left": 48.259705987595424,
                                "width": 23.85496183206107,
                                "height": 21.36449558384762
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_5wUpzFH_Pz1FtoK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Paccheri ripieni di salsiccia, radicchio e besciamella",
                                    "data": {
                                        "ingredients": "Paccheri 12, Radicchio 1, Besciamella 50 g, Provola 100 g, Salsiccia 1, Olio extravergine d'oliva q.b.",
                                        "recipe": "Rosolare la salsiccia e poi aggiungere il pepe e il radicchio tagliato. A metà cottura versare il formaggio, la besciamella e la provola a dadini. Riempire i paccheri e infine guarnire con la restante besciamella e formaggio per poi cuocere in forno per circa 30 minuti a 180°.",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/images/download_7xBTQ5f.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm42378307",
                            "field1": "Involtini/ spiedini",
                            "field2": "di suino con scamorza affumicata",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Involtini/ spiedini di suino con scamorza affumicata al kg",
                            "grammage": null,
                            "price": "9.90",
                            "price_label": "€ 9,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [
                                "Involtini",
                                "Spiedini"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 23.128821116189926,
                                "left": 72.11466781965649,
                                "width": 24.332061068702295,
                                "height": 21.36449558384762
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_2kFkEvi_uLBUmuk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm23390764",
                            "field1": "Hamburger",
                            "field2": "di pollo e tacchino",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Hamburger di pollo e tacchino al kg",
                            "grammage": null,
                            "price": "6.99",
                            "price_label": "€ 6,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 44.49331670003753,
                                "left": 73.66524033874046,
                                "width": 22.781488549618324,
                                "height": 29.391618202056257
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_e0AnHtA_l7S4h74.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm32367167",
                            "field1": "Cosce di pollo",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Cosce di pollo al kg",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 45.97524702955298,
                                "left": 51.003026598282446,
                                "width": 22.66221374045801,
                                "height": 27.909687872540818
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_JIUxZBT_zWkpBof.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm79375424",
                            "field1": "Hamburger di suino",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Hamburger di suino al kg",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 45.97524702955298,
                                "left": 28.340812857824428,
                                "width": 22.662213740458025,
                                "height": 27.909687872540818
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_32NQTPc_dhkq8c6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm26717745",
                            "field1": "Hamburger di bovino adulto",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Hamburger di bovino adulto al kg",
                            "grammage": null,
                            "price": "7.49",
                            "price_label": "€ 7,49 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 45.97524702955298,
                                "left": 3.2931029341603164,
                                "width": 25.047709923664108,
                                "height": 27.909687872540818
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_UUFVi7w_qE2IvZA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm73995705",
                            "field1": "Ceres",
                            "field2": "birra strong ale",
                            "field3": "cl.33x3",
                            "field4": "",
                            "description": "Ceres birra strong ale cl.33x3",
                            "grammage": null,
                            "price": "4.49",
                            "price_label": "€ 4,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 76.23132459049324,
                                "left": 3.5316525524809164,
                                "width": 45.44370229007634,
                                "height": 19.141600089574457
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_tbhma0I_cdj5fOC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/SPOT_CERES_-_LA_CITT%C3%80_HA_BISOGNO_DI_EROI__spot_2012.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm83066666",
                            "field1": "Masi",
                            "field2": "vino valpolicella classico D.O.C.",
                            "field3": "bonacosta cl.75",
                            "field4": "",
                            "description": "Masi vino valpolicella classico D.O.C. bonacosta cl.75",
                            "grammage": null,
                            "price": "8.99",
                            "price_label": "€ 8,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 76.23132459049324,
                                "left": 48.97535484255726,
                                "width": 23.61641221374046,
                                "height": 19.141600089574457
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_NODa2K8_98Kcny6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm10209883",
                            "field1": "Cantine due palme",
                            "field2": "vino I.G.P. susumaniello",
                            "field3": "serre salento cl.75",
                            "field4": "",
                            "description": "Cantine due palme vino I.G.P. susumaniello serre salento cl.75",
                            "grammage": null,
                            "price": "9.99",
                            "price_label": "€ 9,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 76.23132459049324,
                                "left": 72.59176705629773,
                                "width": 18.010496183206108,
                                "height": 19.141600089574457
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ErDRGBD_lrNDCnA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 10,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_10_uDP0Ha2.jpg",
                    "products": [
                        {
                            "item_id": "cstm56040044",
                            "field1": "Jentu",
                            "field2": "iceberg e carote",
                            "field3": "gr.300",
                            "field4": "",
                            "description": "Jentu iceberg e carote gr.300",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 9.173977179919513,
                                "left": 3.2931029341603058,
                                "width": 20.157442748091604,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_m8AJjq4_qcZxuyd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm15983278",
                            "field1": "Develey",
                            "field2": "salsa barbecure/ messicana/",
                            "field3": "greca/ burger",
                            "field4": "ml.250",
                            "description": "Develey salsa barbecure/ messicana/ greca/ burger ml.250",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Salsa barbecure",
                                "Messicana",
                                "Greca",
                                "Burger"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.173977179919513,
                                "left": 23.450545682251906,
                                "width": 16.34064885496183,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_c7wj9Hy_Wo9ZJ8A.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm42087017",
                            "field1": "Bonduelle",
                            "field2": "iceberg",
                            "field3": "gr.200",
                            "field4": "",
                            "description": "Bonduelle iceberg gr.200",
                            "grammage": null,
                            "price": "1.20",
                            "price_label": "€ 1,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 9.173977179919513,
                                "left": 39.79119453721374,
                                "width": 20.51526717557252,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_i2CDG1U_9g3j2iy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Iceberg",
                                        "testo": "L’Iceberg Bonduelle è un’insalata dolce e croccante dal cuore di ghiaccio, amata anche dai bambini. Il suo sapore delicato la rende ideale come contorno leggero e perfetta come base per sfiziosi piatti unici. (Fonte: bonduelle.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/images/08006862003991_BND_3D_S_IMPEGNA_INSALATE_ICEBERG_200g_SENZA_RESIDUO_DI_ioxFfIM.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm64011613",
                            "field1": "Nocciole pelate tostate",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Nocciole pelate tostate al kg",
                            "grammage": null,
                            "price": "13.99",
                            "price_label": "€ 13,99 al Kg",
                            "equivalence": 10,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.173977179919513,
                                "left": 60.30646171278626,
                                "width": 19.918893129770993,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_3NR0dU9_17rK7tx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm33200599",
                            "field1": "Pistacchi con guscio",
                            "field2": "tostati e salati",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Pistacchi con guscio tostati e salati al kg",
                            "grammage": null,
                            "price": "14.99",
                            "price_label": "€ 14,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.173977179919513,
                                "left": 80.22535484255725,
                                "width": 16.45992366412214,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ZQwTQUa_urnLV0c.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm77521615",
                            "field1": "Melanzane",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Melanzane al kg",
                            "grammage": null,
                            "price": "1.19",
                            "price_label": "€ 1,19 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 30.661966957893416,
                                "left": 50.645202170801525,
                                "width": 46.04007633587786,
                                "height": 21.611483972100192
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Ver9xr8_pug87UM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17372984",
                            "field1": "Anguria",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Anguria al kg",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 52.2734509299936,
                                "left": 73.78451514790078,
                                "width": 22.900763358778622,
                                "height": 20.623530419089896
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_UqyXcJZ_8RWZlEp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm69720284",
                            "field1": "Madre terra",
                            "field2": "funghi champignon crema",
                            "field3": "gr.250 al pz",
                            "field4": "",
                            "description": "Madre terra funghi champignon crema gr.250 al pz",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 72.8969813490835,
                                "left": 73.78451514790078,
                                "width": 22.900763358778622,
                                "height": 22.84642591336306
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ZLMPQ6a_EkppCvU.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60606716",
                            "field1": "Noci pecan",
                            "field2": "gr.250 al pz",
                            "field3": "",
                            "field4": "",
                            "description": "Noci pecan gr.250 al pz",
                            "grammage": null,
                            "price": "4.69",
                            "price_label": "€ 4,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 82.28254010268131,
                                "left": 50.28737774332061,
                                "width": 23.497137404580158,
                                "height": 13.460867159765263
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_qNAjMsM_8dwXSjZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm02654254",
                            "field1": "Zucchine",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Zucchine al kg",
                            "grammage": null,
                            "price": "1.19",
                            "price_label": "€ 1,19 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 67.21624841927431,
                                "left": 50.28737774332061,
                                "width": 23.497137404580158,
                                "height": 15.06629168340699
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_8xSHdE5_4HZVCp5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm82050905",
                            "field1": "Albicocche",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Albicocche al kg",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 52.39694512411989,
                                "left": 50.28737774332061,
                                "width": 23.497137404580158,
                                "height": 14.81930329515442
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_AOJ8Ncm_MD49xH2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm19646008",
                            "field1": "Melone giallo",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Melone giallo al kg",
                            "grammage": null,
                            "price": "1.19",
                            "price_label": "€ 1,19 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 30.785461152019703,
                                "left": 3.5316525524809164,
                                "width": 46.159351145038165,
                                "height": 21.611483972100192
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_znP60z1_UWol9wA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm82982134",
                            "field1": "Pomodoro rosso grappolo",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Pomodoro rosso grappolo al kg",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 52.39694512411989,
                                "left": 26.432415911259543,
                                "width": 23.258587786259543,
                                "height": 13.213878771512688
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_cy4s15E_f2WFjqT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm47935165",
                            "field1": "Pomodoro piccaledy",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Pomodoro piccaledy al kg",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 65.61082389563258,
                                "left": 26.432415911259543,
                                "width": 23.258587786259543,
                                "height": 14.32532651864927
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_GMUIgYd_mOOvlT9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Piccadilly",
                                        "testo": "Il Piccadilly è un pomodorino di piccole dimensioni che trae origine dall’antico pomodoro “Vesuviano”, coltivato nel sud Italia. I suoi grappoli contengono dai 15 ai 20 frutti di forma ovale e dal peso di 30-50 grammi ciascuno. È un pomodoro ottimo per preparare salse perché durante la cottura la buccia entra in amalgama con la polpa, ma è ottimo anche in insalata per il suo gusto saporito e dolce. Il colore è un bellissimo rosso vivo. Il grappolo può essere conservato appeso in luogo asciutto ed aerato per diverse settimane mantenendo inalterato il gusto e il profumo. (Fonte: pachineat.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/images/0061792_1611163627.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm37791322",
                            "field1": "De lupinix",
                            "field2": "lupini al sale marino/",
                            "field3": "peperoncino/ lime",
                            "field4": "gr.125",
                            "description": "De lupinix lupini al sale marino/ peperoncino/ lime gr.125",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Lupini al sale marino",
                                "Peperoncino",
                                "Lime"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 79.93615041428185,
                                "left": 26.432415911259543,
                                "width": 23.258587786259543,
                                "height": 15.807256848164712
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ca8gvDj_CY9cVts.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm11002769",
                            "field1": "Patate",
                            "field2": "kg.2 al pz",
                            "field3": "",
                            "field4": "",
                            "description": "Patate kg.2 al pz",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 74.00842909622008,
                                "left": 2.458179270038168,
                                "width": 23.974236641221378,
                                "height": 21.73497816622648
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_3aWHPtE_YxZUc4k.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm45210772",
                            "field1": "Limoni sfusi",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Limoni sfusi al kg",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 52.14995673586731,
                                "left": 2.458179270038168,
                                "width": 23.974236641221378,
                                "height": 21.858472360352764
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_UriXlQt_Ho0zb8M.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 11,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_11_1xpLmAM.jpg",
                    "products": [
                        {
                            "item_id": "cstm80456127",
                            "field1": "Totano decongelato",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Totano decongelato al kg",
                            "grammage": null,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 9.050482985793225,
                                "left": 2.2196296517175576,
                                "width": 23.974236641221378,
                                "height": 21.858472360352764
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_vkI36xU_IpJnW5y.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm55671838",
                            "field1": "Sgombro fresco",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Sgombro fresco al kg",
                            "grammage": null,
                            "price": "6.90",
                            "price_label": "€ 6,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 9.050482985793225,
                                "left": 26.19386629293893,
                                "width": 23.616412213740457,
                                "height": 21.858472360352764
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_NdeLzZ5_C3aOG4b.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm70478307",
                            "field1": "Orate",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Orate al kg",
                            "grammage": null,
                            "price": "6.90",
                            "price_label": "€ 6,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 30.90895534614599,
                                "left": 1.6232556059160306,
                                "width": 48.18702290076335,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_94IXhBl_mdFIDqB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm80366396",
                            "field1": "Gamberoni argentina",
                            "field2": "decongelati confezionati",
                            "field3": "kg.2",
                            "field4": "",
                            "description": "Gamberoni argentina decongelati confezionati kg.2",
                            "grammage": null,
                            "price": "22.90",
                            "price_label": "€ 22,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 9.173977179919513,
                                "left": 49.810278506679396,
                                "width": 47.11354961832061,
                                "height": 43.34646213832667
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_LOCvLyi_Du45QE1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm39620673",
                            "field1": "Trota salmonata",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Trota salmonata al kg",
                            "grammage": null,
                            "price": "7.90",
                            "price_label": "€ 7,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 52.520439318246176,
                                "left": 73.66524033874046,
                                "width": 23.258587786259543,
                                "height": 21.241001389721333
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_lVHx2UA_8InTHWx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm65530712",
                            "field1": "Polpo decongelato",
                            "field2": "già arricciato",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Polpo decongelato già arricciato al kg",
                            "grammage": null,
                            "price": "12.90",
                            "price_label": "€ 12,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 73.76144070796751,
                                "left": 73.66524033874046,
                                "width": 23.258587786259543,
                                "height": 21.611483972100192
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_tTLE5vI_amM0WGm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm09203298",
                            "field1": "Filetto di pesce",
                            "field2": "spada decongelato",
                            "field3": "al kg",
                            "field4": "",
                            "description": "Filetto di pesce spada decongelato al kg",
                            "grammage": null,
                            "price": "17.90",
                            "price_label": "€ 17,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 73.76144070796751,
                                "left": 50.16810293416031,
                                "width": 23.497137404580155,
                                "height": 21.611483972100192
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_K7VhEa1_Bbf9pa9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm23567622",
                            "field1": "Lupini",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Lupini al kg",
                            "grammage": null,
                            "price": "7.90",
                            "price_label": "€ 7,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 52.64393351237246,
                                "left": 50.16810293416031,
                                "width": 23.497137404580155,
                                "height": 21.11750719559505
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_eL8W0VK_w3B8rrh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm38410007",
                            "field1": "Spigola di gallipoli",
                            "field2": "al kg",
                            "field3": "",
                            "field4": "",
                            "description": "Spigola di gallipoli al kg",
                            "grammage": null,
                            "price": "12.90",
                            "price_label": "€ 12,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 52.64393351237246,
                                "left": 3.770202170801527,
                                "width": 46.397900763358784,
                                "height": 42.48200277944267
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_forKrRy_0qSIg3m.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 12,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_12_jmJqd7Z.jpg",
                    "products": [
                        {
                            "item_id": "cstm04247847",
                            "field1": "Granarolo",
                            "field2": "latte uht",
                            "field3": "parzialmente scremato con tappo",
                            "field4": "lt.1",
                            "description": "Granarolo latte uht parzialmente scremato con tappo lt.1",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 3,
                            "quantity_step": 3,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 8.556506209288077,
                                "left": 3.412377743320611,
                                "width": 20.99236641221374,
                                "height": 43.46995633245296
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_EkZ0hCE_mgFLsQd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm42035023",
                            "field1": "Rigoni",
                            "field2": "miele italiano",
                            "field3": "gr.750",
                            "field4": "",
                            "description": "Rigoni miele italiano gr.750",
                            "grammage": null,
                            "price": "6.49",
                            "price_label": "€ 6,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 8.556506209288077,
                                "left": 24.404744155534353,
                                "width": 25.047709923664126,
                                "height": 23.463896883994494
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_tnXVZuZ_lveL5LJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm55760013",
                            "field1": "Yoga",
                            "field2": "succo vari gusti",
                            "field3": "lt.1",
                            "field4": "",
                            "description": "Yoga succo vari gusti lt.1",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Succhi",
                            "blueprint": {
                                "top": 32.020403093282575,
                                "left": 24.404744155534353,
                                "width": 20.51526717557252,
                                "height": 20.376542030837328
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_XAvxHoh_I4uOXrH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.succhiyoga.it/prodotti/pesca-classic/"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm69423734",
                            "field1": "Santal",
                            "field2": "succo senza zuccheri aggiuntivi",
                            "field3": "vari gusti ml.200x3",
                            "field4": "",
                            "description": "Santal succo senza zuccheri aggiuntivi vari gusti ml.200x3",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Succhi",
                            "blueprint": {
                                "top": 33.37883922867172,
                                "left": 44.92001133110687,
                                "width": 23.497137404580155,
                                "height": 19.018105895448173
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_XbP7yNB_F4sNdni.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm30901245",
                            "field1": "Pesche nettarine cestino",
                            "field2": "kg.1 al pz",
                            "field3": "",
                            "field4": "",
                            "description": "Pesche nettarine cestino kg.1 al pz",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 33.37883922867172,
                                "left": 68.41714873568702,
                                "width": 28.26812977099237,
                                "height": 19.018105895448173
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_cTNPYtE_GtUEoMT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm86787828",
                            "field1": "Arborea",
                            "field2": "latte uht scremato/ parzialmente scremato",
                            "field3": "senza lattosio brik con tappo",
                            "field4": "lt.1",
                            "description": "Arborea latte uht scremato/ parzialmente scremato senza lattosio brik con tappo lt.1",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Latte uht scremato",
                                "Parzialmente scremato"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 8.926988791666938,
                                "left": 76.05073652194658,
                                "width": 20.634541984732827,
                                "height": 24.451850437004786
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_uDQFy4A_KkT5Q7k.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm68805328",
                            "field1": "Creapan",
                            "field2": "24 mini pancakes freschi",
                            "field3": "gr.200",
                            "field4": "",
                            "description": "Creapan 24 mini pancakes freschi gr.200",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 8.926988791666938,
                                "left": 50.764476979961835,
                                "width": 25.286259541984734,
                                "height": 24.451850437004786
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_tMLDUH6_1lChcIK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm08015491",
                            "field1": "Lavazza suerte",
                            "field2": "4x250g",
                            "field3": "",
                            "field4": "",
                            "description": "Lavazza suerte 4x250g",
                            "grammage": null,
                            "price": "4.59",
                            "price_label": "€ 4,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 53.508392871256476,
                                "left": 26.909515147900763,
                                "width": 23.02003816793893,
                                "height": 23.58739107812078
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_OlEpniN_oi759p5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm12200829",
                            "field1": "A modo mio suerte nero",
                            "field2": "12 capsule",
                            "field3": "",
                            "field4": "",
                            "description": "A modo mio suerte nero 12 capsule",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 77.09578394937726,
                                "left": 26.909515147900763,
                                "width": 23.02003816793893,
                                "height": 16.918704595301293
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_EqcYO86_hHXa4xo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm77398945",
                            "field1": "Balocco",
                            "field2": "biscotti vari tipi",
                            "field3": "gr.700",
                            "field4": "",
                            "description": "Balocco biscotti vari tipi gr.700",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.2734509299936,
                                "left": 51.59940064408397,
                                "width": 22.1851145038168,
                                "height": 21.611483972100192
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_y4f8WEy_T4br8Dh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm75214557",
                            "field1": "Barilla",
                            "field2": "cecille biscotti con farina",
                            "field3": "di ceci cacao e arancia",
                            "field4": "gr.220",
                            "description": "Barilla cecille biscotti con farina di ceci cacao e arancia gr.220",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.2734509299936,
                                "left": 73.78451514790078,
                                "width": 24.212786259541986,
                                "height": 21.611483972100192
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_isomWqL_nuoTik8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.mulinobianco.it/cecille"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm14536757",
                            "field1": "Crich",
                            "field2": "frollini vari gusti",
                            "field3": "gr.250/270/300",
                            "field4": "",
                            "description": "Crich frollini vari gusti gr.250/270/300",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.88493490209379,
                                "left": 73.78451514790078,
                                "width": 24.212786259541986,
                                "height": 21.36449558384762
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_utCChho_GhQihmH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm34643449",
                            "field1": "Di leo caserecci",
                            "field2": "biscotti vari tipi",
                            "field3": "gr.600/700",
                            "field4": "",
                            "description": "Di leo caserecci biscotti vari tipi gr.600/700",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.88493490209379,
                                "left": 50.764476979961835,
                                "width": 23.02003816793893,
                                "height": 21.36449558384762
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_acLKBwu_z2p40nx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 13,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_13_PErUqqP.jpg",
                    "products": [
                        {
                            "item_id": "cstm27721815",
                            "field1": "Borbone",
                            "field2": "miscela nobile 10 capsule compatibili nespresso/",
                            "field3": "lavazza/ miscela decisa 15 cialde",
                            "field4": "",
                            "description": "Borbone miscela nobile 10 capsule compatibili nespresso/ lavazza/ miscela decisa 15 cialde",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "10 capsule compatibili nespresso",
                                "Lavazza",
                                "Miscela decisa 15 cialde"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 9.544459762298374,
                                "left": 0.0,
                                "width": 20.634541984732824,
                                "height": 21.36449558384762
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_48sjzrM_pz2IW5j.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm06256297",
                            "field1": "Saicaf",
                            "field2": "gran crema caffè",
                            "field3": "gr.250x2",
                            "field4": "",
                            "description": "Saicaf gran crema caffè gr.250x2",
                            "grammage": null,
                            "price": "2.79",
                            "price_label": "€ 2,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.544459762298374,
                                "left": 20.634541984732824,
                                "width": 19.56106870229008,
                                "height": 21.36449558384762
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_CDqTZMz_Tyydy6t.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm49064807",
                            "field1": "Nescafe'",
                            "field2": "cappuccino",
                            "field3": "gr.56",
                            "field4": "",
                            "description": "Nescafe' cappuccino gr.56",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 9.544459762298374,
                                "left": 40.1956106870229,
                                "width": 15.744274809160304,
                                "height": 21.36449558384762
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_0ql3iVe_ZYjoxVo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm40888992",
                            "field1": "Boschetti",
                            "field2": "confettura",
                            "field3": "vari gusti gr.400",
                            "field4": "",
                            "description": "Boschetti confettura vari gusti gr.400",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.90895534614599,
                                "left": 37.9293893129771,
                                "width": 18.010496183206104,
                                "height": 21.241001389721333
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_9758eTD_f6wGVMO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm77532813",
                            "field1": "Nestlè orzoro",
                            "field2": "macinato gr.500",
                            "field3": "",
                            "field4": "",
                            "description": "Nestlè orzoro macinato gr.500",
                            "grammage": null,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.90895534614599,
                                "left": 20.51526717557252,
                                "width": 17.414122137404583,
                                "height": 21.241001389721333
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_LXCUvvf_N1w0ff3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm76982690",
                            "field1": "L'angelica",
                            "field2": "tisana a freddo",
                            "field3": "vari tipi 18 filtri",
                            "field4": "",
                            "description": "L'angelica tisana a freddo vari tipi 18 filtri",
                            "grammage": null,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.90895534614599,
                                "left": 1.3120229007633615,
                                "width": 19.20324427480916,
                                "height": 21.241001389721333
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_BVn0yUM_UYHTnyu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm14542411",
                            "field1": "Ferrero",
                            "field2": "nutella",
                            "field3": "gr.900",
                            "field4": "",
                            "description": "Ferrero nutella gr.900",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.14995673586731,
                                "left": 1.3120229007633615,
                                "width": 19.20324427480916,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_QvzeEFN_ARsS2Ri.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Nutella.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm52536682",
                            "field1": "Bonavita",
                            "field2": "corn flakes",
                            "field3": "gr.500",
                            "field4": "",
                            "description": "Bonavita corn flakes gr.500",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.14995673586731,
                                "left": 20.51526717557252,
                                "width": 20.87309160305344,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_V7s5Zij_IPnxhEV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm31658015",
                            "field1": "Ferrero",
                            "field2": "kinder pan e cioc",
                            "field3": "gr.290",
                            "field4": "",
                            "description": "Ferrero kinder pan e cioc gr.290",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.14995673586731,
                                "left": 41.38835877862596,
                                "width": 18.84541984732824,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_bODpL5d_R01F5vB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Kinder_pan_e_cioc_spot_2017.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm85696773",
                            "field1": "Barilla",
                            "field2": "nastrine integrali",
                            "field3": "gr.240",
                            "field4": "",
                            "description": "Barilla nastrine integrali gr.240",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.14995673586731,
                                "left": 60.233778625954194,
                                "width": 17.652671755725194,
                                "height": 21.487989777973908
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_PrBS833_T7GiRLP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm61153596",
                            "field1": "Barilla",
                            "field2": "8 flauti latte/ cioccolato/",
                            "field3": "stracciatella gr.280",
                            "field4": "",
                            "description": "Barilla 8 flauti latte/ cioccolato/ stracciatella gr.280",
                            "grammage": null,
                            "price": "1.85",
                            "price_label": "€ 1,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Latte",
                                "Cioccolato",
                                "Stracciatella"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.14995673586731,
                                "left": 77.8864503816794,
                                "width": 19.441793893129766,
                                "height": 21.48798977797391
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_jb4pQ7h_wIFhfXN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Mulino_Bianco_Flauti.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm28945454",
                            "field1": "Granarolo",
                            "field2": "bevanda vegetale uht mandorla/",
                            "field3": "nocciola/ cocco/ avena",
                            "field4": "lt.1",
                            "description": "Granarolo bevanda vegetale uht mandorla/ nocciola/ cocco/ avena lt.1",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Mandorla",
                                "Nocciola",
                                "Cocco",
                                "Avena"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 73.63794651384121,
                                "left": 79.19847328244276,
                                "width": 18.12977099236641,
                                "height": 21.858472360352764
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_rKi7261_QQQog3w.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm21894933",
                            "field1": "Cereal drink",
                            "field2": "soiadrink calcio",
                            "field3": "lt.1",
                            "field4": "",
                            "description": "Cereal drink soiadrink calcio lt.1",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 73.63794651384121,
                                "left": 61.665076335877856,
                                "width": 17.53339694656489,
                                "height": 21.858472360352764
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_wm21Zss_dwOVJ50.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17948098",
                            "field1": "Barilla",
                            "field2": "camille gr.304",
                            "field3": "",
                            "field4": "",
                            "description": "Barilla camille gr.304",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.63794651384121,
                                "left": 42.70038167938932,
                                "width": 18.964694656488547,
                                "height": 21.858472360352764
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_HSdP7IY_RG4EqH8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm00491826",
                            "field1": "7 Days",
                            "field2": "Mini croissant cacao/",
                            "field3": "crema/ fragole gr.60",
                            "field4": "",
                            "description": "7 Days Mini croissant cacao/ crema/ fragole gr.60",
                            "grammage": null,
                            "price": "0.50",
                            "price_label": "€ 0,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Cacao",
                                "Crema",
                                "Fragola"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.63794651384121,
                                "left": 21.827290076335878,
                                "width": 20.87309160305344,
                                "height": 21.858472360352764
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_PszNwSn_HFerVsE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm16966604",
                            "field1": "Midì",
                            "field2": "merendine",
                            "field3": "vari tipi",
                            "field4": "",
                            "description": "Midì merendine vari tipi",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.63794651384121,
                                "left": 2.146946564885499,
                                "width": 19.68034351145038,
                                "height": 21.858472360352764
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_b0CXtxh_a3nGSU8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm87095096",
                            "field1": "Dolcificante liquido zero",
                            "field2": "50 ml",
                            "field3": "",
                            "field4": "",
                            "description": "Dolcificante liquido zero 50 ml",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 33.99631019930316,
                                "left": 56.29770992366413,
                                "width": 15.267175572519081,
                                "height": 18.400634924816735
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Cu5UCbs_WTjVgfH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm54467450",
                            "field1": "Truvia dolcificante",
                            "field2": "150 gr",
                            "field3": "",
                            "field4": "",
                            "description": "Truvia dolcificante 150 gr",
                            "grammage": null,
                            "price": "2.79",
                            "price_label": "€ 2,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 24.36376305745279,
                                "left": 71.56488549618321,
                                "width": 13.239503816793896,
                                "height": 28.033182066667106
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_UkVeiKT_87hDwt1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm72933842",
                            "field1": "Truvia astuccio",
                            "field2": "x40",
                            "field3": "",
                            "field4": "",
                            "description": "Truvia astuccio x40",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 29.303530822504264,
                                "left": 84.8043893129771,
                                "width": 11.808206106870228,
                                "height": 23.09341430161563
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_1St4h0R_ywboYu3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 14,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_14_7om0Xez.jpg",
                    "products": [
                        {
                            "item_id": "cstm90746258",
                            "field1": "Divella",
                            "field2": "farina tipo \"00\"/ \"0\"",
                            "field3": "kg.1",
                            "field4": "",
                            "description": "Divella farina tipo \"00\"/ \"0\" kg.1",
                            "grammage": null,
                            "price": "0.50",
                            "price_label": "€ 0,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "00",
                                "0"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.00497607330778,
                                "left": 3.5583107706326222,
                                "width": 20.926390721904692,
                                "height": 43.05970149253731
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_mgiqJMU_dR6pA4H.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm93264308",
                            "field1": "La molisana",
                            "field2": "pasta formati tradizionali",
                            "field3": "vari tipi",
                            "field4": "gr.500",
                            "description": "La molisana pasta formati tradizionali vari tipi gr.500",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 3,
                            "quantity_step": 3,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 9.00497607330778,
                                "left": 24.484701492537315,
                                "width": 25.3230947020042,
                                "height": 43.05970149253731
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_pe5Ah9n_GROfqZA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm28626749",
                            "field1": "Galbusera",
                            "field2": "riso su riso cracker",
                            "field3": "gr.380",
                            "field4": "",
                            "description": "Galbusera riso su riso cracker gr.380",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.00497607330778,
                                "left": 49.807796194541524,
                                "width": 23.929601990049747,
                                "height": 21.915423834501805
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_akkMQ8H_eIVGhgH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm86588381",
                            "field1": "Forno damiani",
                            "field2": "croccantelle bacon/ ketchup/",
                            "field3": "prosciutto",
                            "field4": "gr.35x6",
                            "description": "Forno damiani croccantelle bacon/ ketchup/ prosciutto gr.35x6",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bacon",
                                "Ketchup",
                                "Prosciutto"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Snack",
                            "blueprint": {
                                "top": 9.00497607330778,
                                "left": 73.73739818459127,
                                "width": 23.761425722416362,
                                "height": 21.915423834501805
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Uqk7rdW_NrCzihC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm19355280",
                            "field1": "Divella",
                            "field2": "farina per pizza",
                            "field3": "kg.1",
                            "field4": "",
                            "description": "Divella farina per pizza kg.1",
                            "grammage": null,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.92039990780959,
                                "left": 73.73739818459127,
                                "width": 23.761425722416362,
                                "height": 21.36816110183944
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_09HtBDV_OSRrEMK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm79121385",
                            "field1": "C.R.M.",
                            "field2": "piada sfogliata supersottile gr.330/",
                            "field3": "base per pizza classica gr.420",
                            "field4": "",
                            "description": "C.R.M. piada sfogliata supersottile gr.330/ base per pizza classica gr.420",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Supersottile",
                                "Base per pizza classica"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.92039990780959,
                                "left": 51.48960286325484,
                                "width": 22.247795321336433,
                                "height": 21.36816110183944
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ZrW2JXd_PYW1sy9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm54710685",
                            "field1": "Eurocompany",
                            "field2": "farina di cocco",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "Eurocompany farina di cocco gr.250",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.31343283582088,
                                "left": 76.83672510308412,
                                "width": 22.247795321336433,
                                "height": 21.36816110183944
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_jqP7fP9_u5aFtjQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm37789435",
                            "field1": "Desantis",
                            "field2": "olio di semi di arachide",
                            "field3": "lt.1",
                            "field4": "",
                            "description": "Desantis olio di semi di arachide lt.1",
                            "grammage": null,
                            "price": "2.79",
                            "price_label": "€ 2,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Olio",
                            "blueprint": {
                                "top": 52.31343283582088,
                                "left": 57.88043301046191,
                                "width": 18.95629209262222,
                                "height": 21.36816110183944
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_CBg45an_keL4S8U.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm19501743",
                            "field1": "Clemente",
                            "field2": "achille olio extravergine d'oliva",
                            "field3": "estratto a freddo",
                            "field4": "lt.1",
                            "description": "Clemente achille olio extravergine d'oliva estratto a freddo lt.1",
                            "grammage": null,
                            "price": "3.79",
                            "price_label": "€ 3,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Olio",
                            "blueprint": {
                                "top": 52.31343283582088,
                                "left": 38.27546338513124,
                                "width": 19.604969625330682,
                                "height": 21.36816110183944
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_GrZiWpj_YR93QKQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm13850127",
                            "field1": "Barilla",
                            "field2": "pan bauletto",
                            "field3": "di grano duro",
                            "field4": "gr.400",
                            "description": "Barilla pan bauletto di grano duro gr.400",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.31343283582088,
                                "left": 20.400333507974352,
                                "width": 17.87512987715688,
                                "height": 21.36816110183944
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Vf3GLRZ_0Mr8HXz.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.mulinobianco.it/pan-bauletto-al-grano-duro"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm32838681",
                            "field1": "Barilla",
                            "field2": "pan carrè integrale",
                            "field3": "gr.315",
                            "field4": "",
                            "description": "Barilla pan carrè integrale gr.315",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.31343283582088,
                                "left": 3.0778040065101195,
                                "width": 17.32252950146423,
                                "height": 21.36816110183944
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_hfDmjoY_JFC2VdX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.mulinobianco.it/pancarre-integrale"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm83523382",
                            "field1": "Crich",
                            "field2": "crackers salati/ non salati/",
                            "field3": "integrali",
                            "field4": "gr.500",
                            "description": "Crich crackers salati/ non salati/ integrali gr.500",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Salati",
                                "Non salati",
                                "Integrali"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.68159393766034,
                                "left": 3.0778040065101195,
                                "width": 18.04330064574284,
                                "height": 21.54228665935459
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_DxJQUX9_O3aqu9C.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm75680802",
                            "field1": "Eurocompany",
                            "field2": "pop corn per forno",
                            "field3": "a microonde",
                            "field4": "gr.100",
                            "description": "Eurocompany pop corn per forno a microonde gr.100",
                            "grammage": null,
                            "price": "0.50",
                            "price_label": "€ 0,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.68159393766034,
                                "left": 21.12110465225296,
                                "width": 18.95628659357479,
                                "height": 21.54228665935459
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ZO8hswt_98HhMvm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm77260413",
                            "field1": "Eurocompany",
                            "field2": "arachidi tostate e salate iodate",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "Eurocompany arachidi tostate e salate iodate gr.250",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Snack",
                            "blueprint": {
                                "top": 73.68159393766034,
                                "left": 40.07739124582775,
                                "width": 19.72510181540873,
                                "height": 21.54228665935459
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_zBalkze_If6T8lg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm10755543",
                            "field1": "Centrone",
                            "field2": "misto toast",
                            "field3": "ml.314",
                            "field4": "",
                            "description": "Centrone misto toast ml.314",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.68159393766034,
                                "left": 59.80249306123648,
                                "width": 18.83615440349674,
                                "height": 21.54228665935459
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_FU0a8Sh_3puxe43.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm41134259",
                            "field1": "Calvé",
                            "field2": "maionese vegana senza uova",
                            "field3": "ml.270",
                            "field4": "",
                            "description": "Calvé maionese vegana senza uova ml.270",
                            "grammage": null,
                            "price": "2.19",
                            "price_label": "€ 2,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.68159393766034,
                                "left": 78.63864746473322,
                                "width": 18.76406629097402,
                                "height": 21.54228665935459
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_btWAMlD_IFJLmJh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 15,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_15_7AElCam.jpg",
                    "products": [
                        {
                            "item_id": "cstm79839775",
                            "field1": "Scotti",
                            "field2": "riso parboiled",
                            "field3": "10 minuti non scuoce",
                            "field4": "kg.1",
                            "description": "Scotti riso parboiled 10 minuti non scuoce kg.1",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.37811040166599,
                                "left": 3.9187045913430656,
                                "width": 22.367924761890766,
                                "height": 21.54228665935459
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_GV8MF2d_SRyeFbq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17285204",
                            "field1": "Granoro",
                            "field2": "pasta formati speciali dedicato",
                            "field3": "vari tipi",
                            "field4": "gr.500",
                            "description": "Granoro pasta formati speciali dedicato vari tipi gr.500",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.37811040166599,
                                "left": 26.28662935323383,
                                "width": 23.761431221463795,
                                "height": 21.54228665935459
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ze5hRF3_mscIzXv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm63282989",
                            "field1": "Garofalo",
                            "field2": "gnocchi classici/ integrali",
                            "field3": "gr.500",
                            "field4": "",
                            "description": "Garofalo gnocchi classici/ integrali gr.500",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classici",
                                "Integrali"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 9.37811040166599,
                                "left": 50.04806057469762,
                                "width": 23.689343108941067,
                                "height": 21.54228665935459
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_KN8QMRQ_Z1gDGFH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm54407876",
                            "field1": "Il pastaio maffei",
                            "field2": "pasta fresca orecchiette/",
                            "field3": "trofie/ strozzapreti",
                            "field4": "gr.250",
                            "description": "Il pastaio maffei pasta fresca orecchiette/ trofie/ strozzapreti gr.250",
                            "grammage": null,
                            "price": "0.50",
                            "price_label": "€ 0,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Orecchiette",
                                "Trofie",
                                "Strozzapreti"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 9.37811040166599,
                                "left": 73.73740368363869,
                                "width": 23.401045649324494,
                                "height": 21.54228665935459
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_vlG2yRY_1kUzP6Q.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm42562012",
                            "field1": "Maggi",
                            "field2": "yakisoba classic/",
                            "field3": "chili gr.120/ curry gr.117",
                            "field4": "",
                            "description": "Maggi yakisoba classic/ chili gr.120/ curry gr.117",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Yakisoba classic",
                                "Chili",
                                "Curry"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.920397061020577,
                                "left": 80.94511512642477,
                                "width": 16.19333420653842,
                                "height": 21.11940583186363
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_dEhBxOu_Gn9nj97.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm04530746",
                            "field1": "Star saikebon",
                            "field2": "nudolini orientali cup manzo/ pollo e verdure/",
                            "field3": "gamberetti gr.60/ verdure gr.59",
                            "field4": "",
                            "description": "Star saikebon nudolini orientali cup manzo/ pollo e verdure/ gamberetti gr.60/ verdure gr.59",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Nudolini orientali cup manzo",
                                "Pollo e verdure",
                                "Gamberetti",
                                "Verdure"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.920397061020577,
                                "left": 60.73950654689354,
                                "width": 20.20560857953123,
                                "height": 21.11940583186363
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_nwGvgcw_H2B1R2F.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Saikebon.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm42973147",
                            "field1": "Rana",
                            "field2": "gnocchi/ gnocchetti",
                            "field3": "freschi di patate",
                            "field4": "gr.500",
                            "description": "Rana gnocchi/ gnocchetti freschi di patate gr.500",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Gnocchi",
                                "Gnocchetti"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 30.920397061020577,
                                "left": 44.06566007718518,
                                "width": 16.67384646970835,
                                "height": 21.11940583186363
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_chncifb_1Zd76zR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm35807660",
                            "field1": "Rana sfogliavelo/ duetto",
                            "field2": "pasta fresca ripiena",
                            "field3": "vari gusti",
                            "field4": "gr.250",
                            "description": "Rana sfogliavelo/ duetto pasta fresca ripiena vari gusti gr.250",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Sfogliavelo",
                                "Duetto"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.920397061020577,
                                "left": 24.220431570745827,
                                "width": 19.84522850643935,
                                "height": 21.11940583186363
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_gxRNyCQ_RfrTpgD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Rana",
                                        "testo": "La sfoglia sottile avvolge ed esalta il ripieno più classico della tradizione italiana, amato da grandi e bambini. (Fonte: giovannirana.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/images/SFV-crudo-250g---3D.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51988184",
                            "field1": "Rana",
                            "field2": "lasagne sfogliagrezza/ sfogliavelo",
                            "field3": "gr.250",
                            "field4": "",
                            "description": "Rana lasagne sfogliagrezza/ sfogliavelo gr.250",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Sfogliagrezza",
                                "Sfogliavelo"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.920397061020577,
                                "left": 2.621319281165278,
                                "width": 21.599112289580546,
                                "height": 21.11940583186363
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_AJ3lOEp_o5mR6SX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51560202",
                            "field1": "Barilla",
                            "field2": "farro in chicchi/ mix 5 cereali gr.400/",
                            "field3": "mix cereali e quinoa gr.320",
                            "field4": "",
                            "description": "Barilla farro in chicchi/ mix 5 cereali gr.400/ mix cereali e quinoa gr.320",
                            "grammage": null,
                            "price": "2.19",
                            "price_label": "€ 2,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Farro in chicchi",
                                "Mix 5 cereali",
                                "Mix cereali e quinoa"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.03980289288421,
                                "left": 2.621319281165278,
                                "width": 18.595901021435495,
                                "height": 21.7910447761194
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_GvvP0Ao_PK6t7zY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm11998540",
                            "field1": "Curtiriso",
                            "field2": "riso integrale parboiled",
                            "field3": "kg.1",
                            "field4": "",
                            "description": "Curtiriso riso integrale parboiled kg.1",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.03980289288421,
                                "left": 21.21722030260077,
                                "width": 19.36471349374571,
                                "height": 21.7910447761194
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_yhAqxRB_nTKGo6d.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm21859445",
                            "field1": "Ponti peperlizia",
                            "field2": "insalata per riso classico/",
                            "field3": "light/ funghi gr.350/ per pasta gr.340",
                            "field4": "",
                            "description": "Ponti peperlizia insalata per riso classico/ light/ funghi gr.350/ per pasta gr.340",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Insalata per riso classico",
                                "Light",
                                "Funghi",
                                "Per pasta"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.03980289288421,
                                "left": 40.58193379634648,
                                "width": 21.839373920212935,
                                "height": 21.7910447761194
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_5Q7HUKd_WxZr5r7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm47082705",
                            "field1": "Forno damiani",
                            "field2": "crostini classici",
                            "field3": "gr.150",
                            "field4": "",
                            "description": "Forno damiani crostini classici gr.150",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.03980289288421,
                                "left": 62.42130771655941,
                                "width": 18.043303395266552,
                                "height": 21.7910447761194
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_XbeFd5b_KaYlNPh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm63305292",
                            "field1": "Agromonte",
                            "field2": "patè pomodoro ciliegino",
                            "field3": "vari tipi",
                            "field4": "gr.106",
                            "description": "Agromonte patè pomodoro ciliegino vari tipi gr.106",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.03980289288421,
                                "left": 80.46461111182597,
                                "width": 16.193325957967282,
                                "height": 21.7910447761194
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_FspKoz4_h8UNDKG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm29682607",
                            "field1": "Heinz",
                            "field2": "top down maionese gr.215/",
                            "field3": "ketchup gr.250",
                            "field4": "",
                            "description": "Heinz top down maionese gr.215/ ketchup gr.250",
                            "grammage": null,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Maionese",
                                "Ketchup"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.83084766900362,
                                "left": 71.33483961826532,
                                "width": 25.323097451527918,
                                "height": 21.119408678652636
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_voAnpTD_IyFs1vS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/HEINZ_Ketchup.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm57436321",
                            "field1": "Aia wudy",
                            "field2": "wurstel mini",
                            "field3": "gr.100x4",
                            "field4": "",
                            "description": "Aia wudy wurstel mini gr.100x4",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 73.83084766900362,
                                "left": 45.72343370902598,
                                "width": 25.61140590923935,
                                "height": 21.119408678652636
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_JNsXBJ0_P5lg6Oi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm41530615",
                            "field1": "Roberto",
                            "field2": "pane hamburger/ maxi sesamo gr.300/",
                            "field3": "hot dogs gr.250",
                            "field4": "",
                            "description": "Roberto pane hamburger/ maxi sesamo gr.300/ hot dogs gr.250",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Pane hamburger",
                                "Maxi sesamo",
                                "Hot dogs"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.83084766900362,
                                "left": 20.640606136701592,
                                "width": 25.08282757232439,
                                "height": 21.119408678652636
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_tyh8OoK_C9yzFPq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm81075949",
                            "field1": "Barilla",
                            "field2": "pagnottelle classiche gr.360/",
                            "field3": "hot dog gr.325",
                            "field4": "",
                            "description": "Barilla pagnottelle classiche gr.360/ hot dog gr.325",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classiche",
                                "Hot dog"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.83084766900362,
                                "left": 3.438192328173136,
                                "width": 17.202413808528455,
                                "height": 21.119408678652636
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_l16f3Qo_cqXf01n.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 16,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_16_POqbhoK.jpg",
                    "products": [
                        {
                            "item_id": "cstm44201847",
                            "field1": "Star",
                            "field2": "ragù vari tipi",
                            "field3": "gr.180x2",
                            "field4": "",
                            "description": "Star ragù vari tipi gr.180x2",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.154232651440061,
                                "left": 3.4381950776968497,
                                "width": 22.848453522202973,
                                "height": 21.741298276986655
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_b6fdnkl_RgF0Ga2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Il_Gran_Rag%C3%B9_STAR.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm80613545",
                            "field1": "Knorr",
                            "field2": "Soffritto classico/",
                            "field3": "cipolla gr.130",
                            "field4": "",
                            "description": "Knorr Soffritto classico/ cipolla gr.130",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Soffritto classico",
                                "Cipolla"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.154232651440061,
                                "left": 26.28664859989982,
                                "width": 23.52115584321284,
                                "height": 21.741298276986655
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_kPXxJ9l_arojbRb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm67244377",
                            "field1": "Mare aperto",
                            "field2": "tonno all'olio d'oliva",
                            "field3": "gr.80x8",
                            "field4": "",
                            "description": "Mare aperto tonno all'olio d'oliva gr.80x8",
                            "grammage": null,
                            "price": "4.79",
                            "price_label": "€ 4,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 9.154232651440061,
                                "left": 49.80780444311266,
                                "width": 46.75403072395134,
                                "height": 21.741298276986655
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_sNZdxUI_OZA7wiO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm05673038",
                            "field1": "Biffi",
                            "field2": "sugo cacio e pepe fresco",
                            "field3": "gr.150",
                            "field4": "",
                            "description": "Biffi sugo cacio e pepe fresco gr.150",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.895530928426712,
                                "left": 73.953637776446,
                                "width": 22.608197390618006,
                                "height": 21.41790760097219
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Y5Wh8Kx_2N4NI6k.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm84966553",
                            "field1": "Desantis",
                            "field2": "passata di pomodoro",
                            "field3": "gr.680",
                            "field4": "",
                            "description": "Desantis passata di pomodoro gr.680",
                            "grammage": null,
                            "price": "0.65",
                            "price_label": "€ 0,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 30.895530928426712,
                                "left": 49.9519641710158,
                                "width": 24.001673605430195,
                                "height": 21.41790760097219
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_LLK22Gt_DSBOSvP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm35624359",
                            "field1": "Mutti",
                            "field2": "pomodori pelati",
                            "field3": "gr.400",
                            "field4": "",
                            "description": "Mutti pomodori pelati gr.400",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 3,
                            "quantity_step": 3,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 30.895530928426712,
                                "left": 26.142483372949258,
                                "width": 23.809480798066545,
                                "height": 21.41790760097219
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Isj2GjY_emvi77r.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17094999",
                            "field1": "Mutti",
                            "field2": "polpa di pomodoro",
                            "field3": "ml.210x2",
                            "field4": "",
                            "description": "Mutti polpa di pomodoro ml.210x2",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 30.895530928426712,
                                "left": 2.1408097675190616,
                                "width": 24.001673605430195,
                                "height": 13.45770480027839
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_b2mgNmB_fQhtWcy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm72926654",
                            "field1": "Simmenthal",
                            "field2": "carne in scatola",
                            "field3": "gr.70x3",
                            "field4": "",
                            "description": "Simmenthal carne in scatola gr.70x3",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.3532357287051,
                                "left": 2.1408097675190616,
                                "width": 24.001673605430195,
                                "height": 13.905483075042271
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_qqDYZ4M_YJic8Y6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Simmenthal_Spot_2020_-_15s.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm08723386",
                            "field1": "Rio mare",
                            "field2": "tonno pescato a canna/ piccante/",
                            "field3": "pepe e limone",
                            "field4": "gr.80x3 +1 gratis",
                            "description": "Rio mare tonno pescato a canna/ piccante/ pepe e limone gr.80x3 +1 gratis",
                            "grammage": null,
                            "price": "4.79",
                            "price_label": "€ 4,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Pescato a canna",
                                "Piccante",
                                "Pepe e limone"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 58.25871880374738,
                                "left": 2.1408097675190616,
                                "width": 24.0016736054302,
                                "height": 15.447752653662834
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Mpe1GGP_g2IAJwE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm37899460",
                            "field1": "Tonon",
                            "field2": "rondò original gr.200",
                            "field3": "",
                            "field4": "",
                            "description": "Tonon rondò original gr.200",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.288569550016035,
                                "left": 26.142483372949258,
                                "width": 23.92961023862088,
                                "height": 21.417901907394178
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_VZtcfRK_B5GQyxk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm93732048",
                            "field1": "Crik Crok",
                            "field2": "plus patatine vari tipi gr.100/",
                            "field3": "puff gr.80/ pop corn gr.85",
                            "field4": "",
                            "description": "Crik Crok plus patatine vari tipi gr.100/ puff gr.80/ pop corn gr.85",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Plus patatine",
                                "Puff",
                                "Pop corn"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 52.288569550016035,
                                "left": 50.07209361157013,
                                "width": 23.641285283767175,
                                "height": 21.417901907394178
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_0zDuxDB_q2Z3HIY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm55423009",
                            "field1": "Pai",
                            "field2": "i bianchi fiocchi",
                            "field3": "gr.150",
                            "field4": "",
                            "description": "Pai i bianchi fiocchi gr.150",
                            "grammage": null,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 52.288569550016035,
                                "left": 73.71337889533731,
                                "width": 23.40353652754826,
                                "height": 21.417901907394178
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_sjlRLzp_KdJtjUH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm59227501",
                            "field1": "Haribo",
                            "field2": "caramelle vari tipi",
                            "field3": "gr.175",
                            "field4": "",
                            "description": "Haribo caramelle vari tipi gr.175",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 73.7064714574102,
                                "left": 73.71337889533731,
                                "width": 23.40353652754826,
                                "height": 21.616922065393254
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_5smpp7P_qeFXKtG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm50465888",
                            "field1": "Crik crok",
                            "field2": "patatine classiche",
                            "field3": "gr.400",
                            "field4": "",
                            "description": "Crik crok patatine classiche gr.400",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 73.7064714574102,
                                "left": 50.02653216366745,
                                "width": 23.68684673166987,
                                "height": 21.616922065393254
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_MCYkprE_9tZ4fkZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm42484625",
                            "field1": "Fonzies",
                            "field2": "gr.23,5x9 buste",
                            "field3": "",
                            "field4": "",
                            "description": "Fonzies gr.23,5x9 buste",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 73.7064714574102,
                                "left": 3.5583135201563354,
                                "width": 46.46821864351111,
                                "height": 21.616922065393254
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_rHUpfWv_AtVTK9J.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/FONZIES_NUOVO_SPOT_2020_20s.mp4"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 17,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_17_pHBpI8C.jpg",
                    "products": [
                        {
                            "item_id": "cstm72996522",
                            "field1": "Pizzoli",
                            "field2": "patasnella bastoncini da friggere in forno",
                            "field3": "gr.750",
                            "field4": "",
                            "description": "Pizzoli patasnella bastoncini da friggere in forno gr.750",
                            "grammage": null,
                            "price": "1.89",
                            "price_label": "€ 1,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 9.203980573967321,
                                "left": 3.3150532589623016,
                                "width": 23.18480605746976,
                                "height": 21.76616867976402
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_pcxvu2x_JeV47Xf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm96307389",
                            "field1": "Orogel",
                            "field2": "minestrone leggerezza",
                            "field3": "gr.750",
                            "field4": "",
                            "description": "Orogel minestrone leggerezza gr.750",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 9.203980573967321,
                                "left": 26.499859316432065,
                                "width": 23.42506493857844,
                                "height": 21.76616867976402
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ld0U0KN_0CcrKip.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Minestrone leggerezza",
                                        "testo": "Tante verdure sapientemente dosate per ottenere un minestrone fresco e leggero, ma ricco di sapore. Senza patate né fagioli, il Minestrone Leggerezza contiene meno carboidrati della media dei minestroni tradizionali più venduti e fornisce il 50% di calorie in meno. (Fonte: orogel.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/images/7741_n_Minestrone-leggerezza.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm42804383",
                            "field1": "Findus",
                            "field2": "filetto di merluzzo",
                            "field3": "gr.360",
                            "field4": "",
                            "description": "Findus filetto di merluzzo gr.360",
                            "grammage": null,
                            "price": "5.49",
                            "price_label": "€ 5,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 9.203980573967321,
                                "left": 49.92492425501051,
                                "width": 46.730000436602545,
                                "height": 43.15920160777533
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_N4JRgMo_agTrb8R.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm45056706",
                            "field1": "La valle degli orti",
                            "field2": "fagiolini extrafini",
                            "field3": "gr.600",
                            "field4": "",
                            "description": "La valle degli orti fagiolini extrafini gr.600",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 30.845771618743438,
                                "left": 26.139473744292758,
                                "width": 23.785450510717745,
                                "height": 21.517410562999213
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_0oa5708_hxsYKYQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm92840812",
                            "field1": "Paren",
                            "field2": "cimette di rapa a cubetti",
                            "field3": "kg.1",
                            "field4": "",
                            "description": "Paren cimette di rapa a cubetti kg.1",
                            "grammage": null,
                            "price": "2.59",
                            "price_label": "€ 2,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 30.845771618743438,
                                "left": 2.7144143047617466,
                                "width": 23.42505943953101,
                                "height": 21.517410562999213
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_o2afSnF_J0x51Ew.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm01611634",
                            "field1": "Findus",
                            "field2": "pisellini primavera",
                            "field3": "confezione apri e chiudi",
                            "field4": "gr.750",
                            "description": "Findus pisellini primavera confezione apri e chiudi gr.750",
                            "grammage": null,
                            "price": "3.29",
                            "price_label": "€ 3,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 52.36318218174265,
                                "left": 2.7144143047617466,
                                "width": 31.71392759873499,
                                "height": 21.51741340978822
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_bkni5Rp_9mrPB89.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Spot_Findus_Pisellini_Primavera.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm89590327",
                            "field1": "Buitoni bella napoli",
                            "field2": "pizza margherita classica",
                            "field3": "gr.650",
                            "field4": "",
                            "description": "Buitoni bella napoli pizza margherita classica gr.650",
                            "grammage": null,
                            "price": "3.49",
                            "price_label": "€ 3,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 52.36318218174265,
                                "left": 34.42834190349674,
                                "width": 31.11329414358186,
                                "height": 21.51741340978822
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_h2pQkkq_6ljmVe6.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm49199053",
                            "field1": "Florigel",
                            "field2": "rustici misti/ wurstel",
                            "field3": "kg.1",
                            "field4": "",
                            "description": "Florigel rustici misti/ wurstel kg.1",
                            "grammage": null,
                            "price": "3.49",
                            "price_label": "€ 3,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Rustici misti",
                                "Wurstel"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 52.36318218174265,
                                "left": 65.5416360470786,
                                "width": 32.67495762412228,
                                "height": 21.51741340978822
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_73x87K6_W0a9d3R.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm41318424",
                            "field1": "Findus",
                            "field2": "fish burger/",
                            "field3": "fish&chips burger",
                            "field4": "gr.227",
                            "description": "Findus fish burger/ fish&chips burger gr.227",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fish burger",
                                "Fish&Chips burger"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 73.88059559153086,
                                "left": 65.5416360470786,
                                "width": 32.67495762412228,
                                "height": 21.2686524462344
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_sY05R2P_MkYSxBa.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm97991019",
                            "field1": "Soavegel",
                            "field2": "soavelli crepes ripiene",
                            "field3": "vari gusti",
                            "field4": "gr.200",
                            "description": "Soavegel soavelli crepes ripiene vari gusti gr.200",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 73.88059559153086,
                                "left": 34.42834740254417,
                                "width": 31.113288644534443,
                                "height": 21.2686524462344
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_NNt2CR3_nsuKzna.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm72799180",
                            "field1": "Galbani",
                            "field2": "amemi",
                            "field3": "bocconcini di mozzarella impanati",
                            "field4": "gr.150",
                            "description": "Galbani amemi bocconcini di mozzarella impanati gr.150",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 73.88059559153086,
                                "left": 3.1949320669791024,
                                "width": 31.233415335565066,
                                "height": 21.2686524462344
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_xNLXuNs_gD0ro7q.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 18,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_18_JiDCQeP.jpg",
                    "products": [
                        {
                            "item_id": "cstm32304484",
                            "field1": "Algida",
                            "field2": "Cornetto classico confezione maxi",
                            "field3": "12 coni gr720",
                            "field4": "",
                            "description": "Algida Cornetto classico confezione maxi 12 coni gr720",
                            "grammage": null,
                            "price": "4.29",
                            "price_label": "€ 4,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 9.172055540236423,
                                "left": 3.737113402061863,
                                "width": 92.65463917525776,
                                "height": 85.65862857244515
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_EMXc7ma_nLC72qQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/cornetto_algida.mp4"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 19,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_19_hbTvnas.jpg",
                    "products": [
                        {
                            "item_id": "cstm59723915",
                            "field1": "Algida",
                            "field2": "Magnum bomboniere",
                            "field3": "classica/ caffè",
                            "field4": "gr 104",
                            "description": "Algida Magnum bomboniere classica/ caffè gr 104",
                            "grammage": null,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classica",
                                "Caffè"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 9.172055540236423,
                                "left": 3.737113402061863,
                                "width": 92.78350515463919,
                                "height": 58.43999893260278
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_7uYoL11_DHiZKVR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm08521139",
                            "field1": "Algida",
                            "field2": "Cucciolone mini",
                            "field3": "classico x8 gr 270/ donut x6 gr 240",
                            "field4": "",
                            "description": "Algida Cucciolone mini classico x8 gr 270/ donut x6 gr 240",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classico",
                                "Donut"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 67.61205447283919,
                                "left": 3.737113402061863,
                                "width": 92.78350515463919,
                                "height": 27.48547895003691
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Ft4kbaq_fES85CN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 20,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_20_i0MTRvc.jpg",
                    "products": [
                        {
                            "item_id": "cstm40776369",
                            "field1": "Algida Magnum",
                            "field2": "Magnum vari gusti x3",
                            "field3": "gr 207/216/219/222",
                            "field4": "",
                            "description": "Algida Magnum Magnum vari gusti x3 gr 207/216/219/222",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "",
                            "equivalence": null,
                            "quantity_step": null,
                            "grocery_label": "",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 8.905206230041896,
                                "left": 3.737113402061863,
                                "width": 92.78350515463919,
                                "height": 86.19232719283421
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_14VGEc3_S5g70pB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/spot_Magnum_Double.mp4"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 21,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_21_Uw6DI35.jpg",
                    "products": [
                        {
                            "item_id": "cstm40376309",
                            "field1": "Algida",
                            "field2": "Viennetta vari gusti",
                            "field3": "gr 400",
                            "field4": "",
                            "description": "Algida Viennetta vari gusti gr 400",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 8.905206230041896,
                                "left": 3.737113402061863,
                                "width": 92.78350515463919,
                                "height": 42.2956156658335
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_8ut1mIh_Aw5bytj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm09491044",
                            "field1": "Algida carte d'or",
                            "field2": "Ocean classic",
                            "field3": "gelato vari gusti",
                            "field4": "gr 370/380/400",
                            "description": "Algida carte d'or Ocean classic gelato vari gusti gr 370/380/400",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 51.20082189587541,
                                "left": 3.737113402061863,
                                "width": 92.78350515463919,
                                "height": 44.2969854922925
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_eB8mBeW_RYcgBzY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.sharehappy.it/brands/carte-d-or/carte-dor-products/classici/carte-d'or-pistacchio.html"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 22,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_22_FdE02xl.jpg",
                    "products": [
                        {
                            "item_id": "cstm65379955",
                            "field1": "Negroni",
                            "field2": "prosciutto cotto a cubetti",
                            "field3": "gr.120",
                            "field4": "",
                            "description": "Negroni prosciutto cotto a cubetti gr.120",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 9.328353938771716,
                                "left": 3.5553258876895453,
                                "width": 22.82440673771189,
                                "height": 21.14426769427399
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_rwy11nD_BFQ5tlW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.negroni.com/it/prodotti/salumi-cubetti/cubetti-di-cotto"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm40173177",
                            "field1": "casa moderna",
                            "field2": "Teneroni di prosciutto cotto/",
                            "field3": "cotto e mozzarella",
                            "field4": "gr.150",
                            "description": "casa moderna Teneroni di prosciutto cotto/ cotto e mozzarella gr.150",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Prosciutto cotto",
                                "Cotto e mozzarella"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Carne",
                            "blueprint": {
                                "top": 9.328353938771716,
                                "left": 26.379732625401434,
                                "width": 23.42507318714958,
                                "height": 21.14426769427399
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_YMcg4Aj_lvPgKFE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm11724324",
                            "field1": "Zorbas",
                            "field2": "tzatziki",
                            "field3": "gr.200",
                            "field4": "",
                            "description": "Zorbas tzatziki gr.200",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 30.472621633045705,
                                "left": 26.379732625401434,
                                "width": 23.42507318714958,
                                "height": 21.517424796944233
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_JzITj4G_pXGv14s.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm59840799",
                            "field1": "Aia",
                            "field2": "aequilibrium petto di pollo/",
                            "field3": "tacchino al forno",
                            "field4": "",
                            "description": "Aia aequilibrium petto di pollo/ tacchino al forno",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Aequilibrium petto di pollo",
                                "Tacchino al forno"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 30.472621633045705,
                                "left": 2.1137808496086183,
                                "width": 24.265951775792818,
                                "height": 21.517424796944233
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_vqE23vs_ibyHWiR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm29133623",
                            "field1": "Danone activia",
                            "field2": "Mix&go vari gusti",
                            "field3": "gr.170",
                            "field4": "",
                            "description": "Danone activia Mix&go vari gusti gr.170",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 9.203964916627799,
                                "left": 49.92492975405793,
                                "width": 20.782228244477835,
                                "height": 42.78608436015114
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_IBWQHIM_7jCEKNn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm49387049",
                            "field1": "Danone activia",
                            "field2": "Yogurt vari tipi",
                            "field3": "gr.115/125x4",
                            "field4": "",
                            "description": "Danone activia Yogurt vari tipi gr.115/125x4",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 9.203964916627799,
                                "left": 70.70715799853576,
                                "width": 25.707516060539742,
                                "height": 42.78608436015114
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_I20LawN_dY2bZuG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Lintestino_%C3%A8_lepicentro_della_salute__-_Activia_Fibre.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm12454155",
                            "field1": "Merano",
                            "field2": "yogurt bella vita",
                            "field3": "free senza lattosio",
                            "field4": "vari gusti gr.125x2",
                            "description": "Merano yogurt bella vita free senza lattosio vari gusti gr.125x2",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 51.99004927677895,
                                "left": 72.74935023938839,
                                "width": 23.665323819687117,
                                "height": 21.890532080806903
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_VjJiQ3f_oJGLJcy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm33333582",
                            "field1": "Parmalat",
                            "field2": "yogurt magro/ intero/",
                            "field3": "zymil vari gusti",
                            "field4": "gr.125x8",
                            "description": "Parmalat yogurt magro/ intero/ zymil vari gusti gr.125x8",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Magro",
                                "Intero",
                                "Zymil"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 73.88058135758584,
                                "left": 72.74935023938839,
                                "width": 23.665323819687117,
                                "height": 21.268673797151934
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_xozpdHL_2g8ODjE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm53027830",
                            "field1": "Yomo",
                            "field2": "yogurt greco delta",
                            "field3": "0% vari gusti",
                            "field4": "gr.170",
                            "description": "Yomo yogurt greco delta 0% vari gusti gr.170",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 73.88058135758584,
                                "left": 50.045056445088555,
                                "width": 22.704293794299836,
                                "height": 21.268673797151934
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_RI14Vyi_G1NqMOE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm62566689",
                            "field1": "Bayernland",
                            "field2": "fit dessert frutta",
                            "field3": "assortito",
                            "field4": "gr.125",
                            "description": "Bayernland fit dessert frutta assortito gr.125",
                            "grammage": null,
                            "price": "0.29",
                            "price_label": "€ 0,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 52.611941721901964,
                                "left": 50.045056445088555,
                                "width": 22.704293794299836,
                                "height": 21.268639635683883
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_UUefSip_d11KIl7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99219542",
                            "field1": "Muller",
                            "field2": "i feel good kefir da bere",
                            "field3": "bianco",
                            "field4": "gr.500",
                            "description": "Muller i feel good kefir da bere bianco gr.500",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 52.611941721901964,
                                "left": 30.22385272695058,
                                "width": 19.821203718137976,
                                "height": 21.268639635683883
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_suc8LKW_C2sLta0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm07909212",
                            "field1": "Muller",
                            "field2": "i feel good kefir da bere",
                            "field3": "fragola/ lampone",
                            "field4": "gr.500",
                            "description": "Muller i feel good kefir da bere fragola/ lampone gr.500",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fragola",
                                "Lampone"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 52.611941721901964,
                                "left": 3.435188198564066,
                                "width": 26.78866452838651,
                                "height": 21.268639635683883
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_yPpPFed_vDNdI4m.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm77092904",
                            "field1": "Nestlè sveltesse",
                            "field2": "i love kefir",
                            "field3": "vari gusti",
                            "field4": "gr.170",
                            "description": "Nestlè sveltesse i love kefir vari gusti gr.170",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 73.88058135758584,
                                "left": 3.435188198564066,
                                "width": 46.609870996048194,
                                "height": 21.393055702323345
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_FRTQeST_6zimSfB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 23,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_23_9BSrIuI.jpg",
                    "products": [
                        {
                            "item_id": "cstm30230745",
                            "field1": "Scaldasole",
                            "field2": "voglia di yogurt magro bio",
                            "field3": "vari gusti",
                            "field4": "gr.250",
                            "description": "Scaldasole voglia di yogurt magro bio vari gusti gr.250",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 9.328361055744228,
                                "left": 3.435182699516641,
                                "width": 22.944549925884797,
                                "height": 21.64179104477612
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_lloWDUz_ftdNGQY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm96156009",
                            "field1": "Hopla'",
                            "field2": "panna senza grassi idrogenati",
                            "field3": "ml.200",
                            "field4": "",
                            "description": "Hopla' panna senza grassi idrogenati ml.200",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.328361055744228,
                                "left": 26.379732625401434,
                                "width": 23.665318320639688,
                                "height": 21.64179104477612
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_iSJvuJZ_NnIpNzD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm77222082",
                            "field1": "Formaggio",
                            "field2": "grattugiato mix",
                            "field3": "kg.1",
                            "field4": "",
                            "description": "Formaggio grattugiato mix kg.1",
                            "grammage": null,
                            "price": "6.49",
                            "price_label": "€ 6,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.97015210052035,
                                "left": 26.379732625401434,
                                "width": 23.665318320639688,
                                "height": 21.144277658035506
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_FZdeg5E_EJY2TgM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm16965287",
                            "field1": "Grana padano",
                            "field2": "D.O.P. grattuggiato",
                            "field3": "gr.100",
                            "field4": "",
                            "description": "Grana padano D.O.P. grattuggiato gr.100",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 30.97015210052035,
                                "left": 1.9936376614357134,
                                "width": 24.38609496396572,
                                "height": 21.144277658035506
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_zDl7U4w_ppN2wIQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm01614476",
                            "field1": "Sottilette",
                            "field2": "classiche",
                            "field3": "gr.400",
                            "field4": "",
                            "description": "Sottilette classiche gr.400",
                            "grammage": null,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 9.07960293897942,
                                "left": 50.045056445088555,
                                "width": 46.4897470545413,
                                "height": 17.786068702811626
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_c7B6TsU_IF35QLa.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/SOTTILETTE.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm18060025",
                            "field1": "Philadelphia",
                            "field2": "classico gr.150",
                            "field3": "",
                            "field4": "",
                            "description": "Philadelphia classico gr.150",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 2,
                            "quantity_step": 2,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 26.865671641791046,
                                "left": 50.045056445088555,
                                "width": 46.4897470545413,
                                "height": 25.248758116764808
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Cjeqv80_IFXtefK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/philadelphia.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm28051055",
                            "field1": "Granarolo",
                            "field2": "bersciamella uht",
                            "field3": "ml.200",
                            "field4": "",
                            "description": "Granarolo bersciamella uht ml.200",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 52.11442975855585,
                                "left": 73.8305042062826,
                                "width": 22.70429929334726,
                                "height": 14.427859747587744
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_RiVK6Ex_Nd8fBz9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm65652389",
                            "field1": "Granarolo",
                            "field2": "burro senza lattosio",
                            "field3": "gr.100",
                            "field4": "",
                            "description": "Granarolo burro senza lattosio gr.100",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 66.54228950614359,
                                "left": 73.8305042062826,
                                "width": 22.70429929334726,
                                "height": 15.298504615897563
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_nSDtSpt_3jPfezo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm59168571",
                            "field1": "Exquisa",
                            "field2": "pasta sfoglia light",
                            "field3": "gr.275",
                            "field4": "",
                            "description": "Exquisa pasta sfoglia light gr.275",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 81.84079412204116,
                                "left": 73.8305042062826,
                                "width": 22.70429929334726,
                                "height": 13.308456762513117
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_epvWrQ5_rqgjFvc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm93687322",
                            "field1": "Salmone scozzese affumicato",
                            "field2": "gr.100",
                            "field3": "",
                            "field4": "",
                            "description": "Salmone scozzese affumicato gr.100",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 73.75621510975397,
                                "left": 49.80480031350359,
                                "width": 24.025703892778992,
                                "height": 21.393035774800317
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_hKcibmj_JrGkTL0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm41229404",
                            "field1": "Aia",
                            "field2": "uova allevate all'aperto x4",
                            "field3": "",
                            "field4": "",
                            "description": "Aia uova allevate all'aperto x4",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 52.48756124012506,
                                "left": 49.80480031350359,
                                "width": 24.025703892778992,
                                "height": 21.268653869628906
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_m5nNE7p_BYIoEWm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm29663623",
                            "field1": "Panna chef",
                            "field2": "leggera",
                            "field3": "",
                            "field4": "",
                            "description": "Panna chef leggera",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 52.48756124012506,
                                "left": 21.574590747036154,
                                "width": 28.230209566467437,
                                "height": 12.810940528983501
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_wfvx3HO_8qsPYxM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm56368068",
                            "field1": "Panna chef",
                            "field2": "senza lattosio",
                            "field3": "",
                            "field4": "",
                            "description": "Panna chef senza lattosio",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 65.29850176910855,
                                "left": 21.574590747036154,
                                "width": 28.230209566467437,
                                "height": 13.184086244497728
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_mvF6TWG_sdTunRm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm58942884",
                            "field1": "Panna chef",
                            "field2": "besciamella integrale",
                            "field3": "",
                            "field4": "",
                            "description": "Panna chef besciamella integrale",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 78.48258801360628,
                                "left": 34.54847134405108,
                                "width": 15.25632896945251,
                                "height": 16.91541244734579
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_93WVaKv_8Ppozpm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88670316",
                            "field1": "Chef",
                            "field2": "panna fresca",
                            "field3": "",
                            "field4": "",
                            "description": "Chef panna fresca",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 78.48258801360628,
                                "left": 21.574598995607293,
                                "width": 12.973872348443786,
                                "height": 16.91541244734579
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_7rpjJb5_IC7ROrt.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 24,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_24_i4NKzLI.jpg",
                    "products": [
                        {
                            "item_id": "cstm80306758",
                            "field1": "Santo stefano",
                            "field2": "acqua minerale naturale oligominerale",
                            "field3": "lt.2x6",
                            "field4": "",
                            "description": "Santo stefano acqua minerale naturale oligominerale lt.2x6",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 9.203976303783815,
                                "left": 3.315061507533441,
                                "width": 24.386078466823445,
                                "height": 21.517403446026705
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Z83Wdm6_MtRvhcr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Acqua_Santo_Stefano_-_Tour_promozionale_estate_2017.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm79963460",
                            "field1": "Set 3 bicchieri",
                            "field2": "in  vetro colori assortiti",
                            "field3": "",
                            "field4": "",
                            "description": "Set 3 bicchieri in  vetro colori assortiti",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Stoviglie",
                            "blueprint": {
                                "top": 9.203976303783815,
                                "left": 27.701139974356888,
                                "width": 21.98353364811608,
                                "height": 21.517403446026705
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Jacajpo_wrzVct4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm64272595",
                            "field1": "San benedetto",
                            "field2": "bibite vari tipi",
                            "field3": "lt.1,5",
                            "field4": "",
                            "description": "San benedetto bibite vari tipi lt.1,5",
                            "grammage": null,
                            "price": "0.50",
                            "price_label": "€ 0,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 30.721379749810517,
                                "left": 2.9546786849178512,
                                "width": 23.545177881990497,
                                "height": 21.393045738561828
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_0nYeqwC_Xtigase.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm70560180",
                            "field1": "San benedetto",
                            "field2": "Thè pesca/ limone",
                            "field3": "cl.33",
                            "field4": "",
                            "description": "San benedetto Thè pesca/ limone cl.33",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 3,
                            "quantity_step": 3,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Pesca",
                                "Limone"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 30.721379749810517,
                                "left": 26.49985656690835,
                                "width": 23.184819805088328,
                                "height": 21.393045738561828
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_LBIj9p2_pVm1yqE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm24369353",
                            "field1": "Toka",
                            "field2": "acqua minerale effervescente naturale",
                            "field3": "lt.1,5x6",
                            "field4": "",
                            "description": "Toka acqua minerale effervescente naturale lt.1,5x6",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 9.452720186603603,
                                "left": 50.04505094604113,
                                "width": 46.24949642200375,
                                "height": 42.78608151336215
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_fxFtf9U_6p8YhOu.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm67071091",
                            "field1": "Coca cola",
                            "field2": "classica/ decaffeinata/",
                            "field3": "light/ zero",
                            "field4": "lt.1,5",
                            "description": "Coca cola classica/ decaffeinata/ light/ zero lt.1,5",
                            "grammage": null,
                            "price": "2.59",
                            "price_label": "€ 2,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classica",
                                "Decaffeinata",
                                "Light",
                                "Zero"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 52.23880169996574,
                                "left": 50.04505094604113,
                                "width": 46.24949642200375,
                                "height": 43.15919591419732
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_D941BkQ_pwOnzQt.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Coca-Cola_presenta_Come_Mai_Prima_con_George_the_Poet.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm01722629",
                            "field1": "Gatorade",
                            "field2": "bibite sport drink",
                            "field3": "vari gusti",
                            "field4": "ml.500",
                            "description": "Gatorade bibite sport drink vari gusti ml.500",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 3,
                            "quantity_step": 3,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 52.23880169996574,
                                "left": 3.315069756104581,
                                "width": 46.72998118993654,
                                "height": 43.15919591419732
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_X496hll_iTnhxAL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 25,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_25_yU0Dv7P.jpg",
                    "products": [
                        {
                            "item_id": "cstm71345622",
                            "field1": "Ferrero",
                            "field2": "estathè limone/ pesca",
                            "field3": "lt.1,5",
                            "field4": "",
                            "description": "Ferrero estathè limone/ pesca lt.1,5",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Limone",
                                "Pesca"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 9.203980573967321,
                                "left": 3.5553066410235528,
                                "width": 29.19123134328358,
                                "height": 42.786072972995136
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_5lP80cT_H7uhFY1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm19979169",
                            "field1": "Heineken",
                            "field2": "birra",
                            "field3": "cl.33x3",
                            "field4": "",
                            "description": "Heineken birra cl.33x3",
                            "grammage": null,
                            "price": "2.19",
                            "price_label": "€ 2,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 9.203980573967321,
                                "left": 32.74653798430714,
                                "width": 33.395728768400886,
                                "height": 42.786072972995136
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_NZxZCuG_DZJ203s.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Heineken_-_Stanza_della_Birra.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm49720122",
                            "field1": "Carl theodor",
                            "field2": "birra premium",
                            "field3": "cl.50",
                            "field4": "",
                            "description": "Carl theodor birra premium cl.50",
                            "grammage": null,
                            "price": "0.50",
                            "price_label": "€ 0,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 9.577114902325532,
                                "left": 66.26239894278606,
                                "width": 30.272390809225204,
                                "height": 42.786072972995136
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_zJU8r6Q_z4LMyof.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm69688058",
                            "field1": "Amaro lucano",
                            "field2": "amaro cl.70",
                            "field3": "",
                            "field4": "",
                            "description": "Amaro lucano amaro cl.70",
                            "grammage": null,
                            "price": "8.49",
                            "price_label": "€ 8,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Liquori",
                            "blueprint": {
                                "top": 52.36318787532066,
                                "left": 73.5902425756502,
                                "width": 22.944547176361084,
                                "height": 21.641786774592614
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_2ICi8fc_reWdPc0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Amaro_Lucano_Spot_TV_-_Bar.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm09021822",
                            "field1": "Warsteiner",
                            "field2": "birra fusto",
                            "field3": "lt.5",
                            "field4": "",
                            "description": "Warsteiner birra fusto lt.5",
                            "grammage": null,
                            "price": "9.99",
                            "price_label": "€ 9,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 52.36318787532066,
                                "left": 49.92492425501051,
                                "width": 23.665318320639688,
                                "height": 21.641786774592614
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ARQvqEV_euKE3EM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm06980639",
                            "field1": "Peroni",
                            "field2": "peroncino",
                            "field3": "cl.25x6",
                            "field4": "",
                            "description": "Peroni peroncino cl.25x6",
                            "grammage": null,
                            "price": "3.39",
                            "price_label": "€ 3,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 52.36318787532066,
                                "left": 26.25960593437081,
                                "width": 23.665318320639688,
                                "height": 21.641786774592614
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_8TFboE2_3Ims35b.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm59135228",
                            "field1": "Sanbitter",
                            "field2": "fizz",
                            "field3": "cl.25x3",
                            "field4": "",
                            "description": "Sanbitter fizz cl.25x3",
                            "grammage": null,
                            "price": "2.59",
                            "price_label": "€ 2,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 52.36318787532066,
                                "left": 2.9546676868229977,
                                "width": 23.304938247547817,
                                "height": 21.641786774592614
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_a59eHB4_cyEa8ma.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm10445856",
                            "field1": "Matusalem",
                            "field2": "rum solera 7 anni",
                            "field3": "cl.70",
                            "field4": "",
                            "description": "Matusalem rum solera 7 anni cl.70",
                            "grammage": null,
                            "price": "14.90",
                            "price_label": "€ 14,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 74.00497464991327,
                                "left": 2.9546676868229977,
                                "width": 23.304938247547817,
                                "height": 21.144290468586025
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_65pAACs_xjkEbsm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm87075290",
                            "field1": "Frescobaldi",
                            "field2": "vino calaforte",
                            "field3": "rosè toscana I.G.T.",
                            "field4": "cl.75",
                            "description": "Frescobaldi vino calaforte rosè toscana I.G.T. cl.75",
                            "grammage": null,
                            "price": "6.99",
                            "price_label": "€ 6,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 74.00497464991327,
                                "left": 26.25960593437081,
                                "width": 23.064671117868,
                                "height": 21.144290468586025
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_g1n1FkD_0W9uyVU.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm37498056",
                            "field1": "La cacciatora",
                            "field2": "vino frizzante pinot rosa/",
                            "field3": "chardonnay/ verduzzo",
                            "field4": "cl.75",
                            "description": "La cacciatora vino frizzante pinot rosa/ chardonnay/ verduzzo cl.75",
                            "grammage": null,
                            "price": "3.29",
                            "price_label": "€ 3,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Rosa",
                                "Chardonnay",
                                "Verduzzo"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 74.00497464991327,
                                "left": 49.3242770522388,
                                "width": 25.707507811968597,
                                "height": 21.144290468586025
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_myvi0YH_v8LXmUc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm33427215",
                            "field1": "Frizzoro",
                            "field2": "bianco/ rosso",
                            "field3": "vino amabile",
                            "field4": "lt.1,5",
                            "description": "Frizzoro bianco/ rosso vino amabile lt.1,5",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Rosso",
                                "Bianco"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 74.00497464991327,
                                "left": 75.0317848642074,
                                "width": 21.262748756218905,
                                "height": 21.144290468586025
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_7F5ogHw_kfUhVpJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 26,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_26_DqCP1Vl.jpg",
                    "products": [
                        {
                            "item_id": "cstm92666317",
                            "field1": "Plasmon",
                            "field2": "Omogeneizzato ",
                            "field3": "Ceci e zucca/ Lenticchie/ Legumi verdi/ Borlotti",
                            "field4": "gr 80x2",
                            "description": "Plasmon Omogeneizzato  Ceci e zucca/ Lenticchie/ Legumi verdi/ Borlotti gr 80x2",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Ceci e zucca",
                                "Lenticchie",
                                "Legumi verdi",
                                "Borlotti"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 10.106028125917287,
                                "left": 4.25257731958763,
                                "width": 24.0979381443299,
                                "height": 20.28054757478452
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_tEL7Msx_iaov110.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm16938643",
                            "field1": "Plasmon",
                            "field2": "Omogeneizzati carne",
                            "field3": "vari gusti",
                            "field4": "gr 80x2",
                            "description": "Plasmon Omogeneizzati carne vari gusti gr 80x2",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Prima infanzia",
                            "subcategory": "Puericultura",
                            "blueprint": {
                                "top": 10.106028125917287,
                                "left": 28.350515463917528,
                                "width": 23.324742268041238,
                                "height": 20.28054757478452
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_RmtpzfZ_RuKB3c0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm55200431",
                            "field1": "Plasmon",
                            "field2": "Biscotto ottuplo",
                            "field3": "gr 720",
                            "field4": "",
                            "description": "Plasmon Biscotto ottuplo gr 720",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 10.106028125917287,
                                "left": 51.675257731958766,
                                "width": 28.479381443298973,
                                "height": 20.28054757478452
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_7prxyoD_a1rbrzD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Plasmon.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm47719434",
                            "field1": "Plasmon",
                            "field2": "Pastina vari tipi",
                            "field3": "gr 340",
                            "field4": "",
                            "description": "Plasmon Pastina vari tipi gr 340",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 10.106028125917287,
                                "left": 80.15463917525774,
                                "width": 17.2680412371134,
                                "height": 20.28054757478452
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_6kaQpi7_yNrTspw.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm48662584",
                            "field1": "Pampers sole e luna",
                            "field2": "Pannolini esapack",
                            "field3": "varie misure",
                            "field4": "",
                            "description": "Pampers sole e luna Pannolini esapack varie misure",
                            "grammage": null,
                            "price": "17.99",
                            "price_label": "€ 17,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Prima infanzia",
                            "subcategory": "Puericultura",
                            "blueprint": {
                                "top": 30.386575700701805,
                                "left": 58.50515463917526,
                                "width": 38.91752577319588,
                                "height": 22.14849274614625
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_A7xlXsi_qOVLdZB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm44237592",
                            "field1": "Nestlè galak",
                            "field2": "Snack gr 26x4",
                            "field3": "",
                            "field4": "",
                            "description": "Nestlè galak Snack gr 26x4",
                            "grammage": null,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 30.386575700701805,
                                "left": 40.33505154639176,
                                "width": 18.170103092783506,
                                "height": 22.14849274614625
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_YJJ7Ngs_2XbS4a7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm02284499",
                            "field1": "Nestlè fruttolo",
                            "field2": "Maxiduo fragola e pesca/ fragola e vaniglia/ fragola e fiordilatte",
                            "field3": "gr 100x4",
                            "field4": "",
                            "description": "Nestlè fruttolo Maxiduo fragola e pesca/ fragola e vaniglia/ fragola e fiordilatte gr 100x4",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fragola e pesca",
                                "Fragola e vaniglia",
                                "Fragola e fiordilatte"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 30.386575700701805,
                                "left": 18.427835051546392,
                                "width": 21.90721649484536,
                                "height": 22.14849274614625
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_2sStc0w_U3ChuPM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Fr%C3%B9ttolo_Maxi_Duo_due_gusti_da_mischiare_nel_formato_da_100_grammi..mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm76760396",
                            "field1": "Parmalat",
                            "field2": "Latte UHT prima crescita",
                            "field3": "ml 500",
                            "field4": "",
                            "description": "Parmalat Latte UHT prima crescita ml 500",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 30.386575700701805,
                                "left": 3.4793814432989687,
                                "width": 14.948453608247425,
                                "height": 22.14849274614625
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ZZy6uh8_957lUvf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm86582565",
                            "field1": "Special dog",
                            "field2": "excellence maxi/ medium",
                            "field3": "kg.3",
                            "field4": "",
                            "description": "Special dog excellence maxi/ medium kg.3",
                            "grammage": null,
                            "price": "6.29",
                            "price_label": "€ 6,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Maxi",
                                "Medium"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 52.48755269975804,
                                "left": 3.1949320669791024,
                                "width": 18.980305882828745,
                                "height": 21.393042891772822
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_joUplBg_5w0R8WP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99637404",
                            "field1": "One",
                            "field2": "cat sterilcat cereali&manzo/",
                            "field3": "rice/ salmone&riso",
                            "field4": "gr.800",
                            "description": "One cat sterilcat cereali&manzo/ rice/ salmone&riso gr.800",
                            "grammage": null,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Cereali&manzo",
                                "Rice",
                                "Salmone&riso"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 52.48755269975804,
                                "left": 22.175237949807844,
                                "width": 25.58737837141426,
                                "height": 21.393042891772822
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_mqFkpbM_ZDvIWGJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm18650278",
                            "field1": "Morando miglior gatto",
                            "field2": "crocchette vari gusti",
                            "field3": "kg.2",
                            "field4": "",
                            "description": "Morando miglior gatto crocchette vari gusti kg.2",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 52.48755269975804,
                                "left": 47.76261632122211,
                                "width": 19.701077027107353,
                                "height": 21.393042891772822
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_4TaEBbG_yBplb94.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm29062906",
                            "field1": "Morando miglior cane",
                            "field2": "junior crocchette di pollo/",
                            "field3": "mini crocchette di manzo",
                            "field4": "kg.1,5",
                            "description": "Morando miglior cane junior crocchette di pollo/ mini crocchette di manzo kg.1,5",
                            "grammage": null,
                            "price": "2.79",
                            "price_label": "€ 2,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Junior crocchette di pollo",
                                "Mini crocchette di manzo"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 52.48755269975804,
                                "left": 67.46369334832946,
                                "width": 29.07110740177667,
                                "height": 21.393042891772822
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_KcyBUvY_bZ60MCt.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm44490503",
                            "field1": "Vitakraft",
                            "field2": "gioco in peluche per cani",
                            "field3": "con anello di gomma",
                            "field4": "",
                            "description": "Vitakraft gioco in peluche per cani con anello di gomma",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Care",
                            "blueprint": {
                                "top": 73.88059559153086,
                                "left": 74.07075483882012,
                                "width": 22.464045911286007,
                                "height": 21.019888635891586
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_yMaLcKb_JqWEHfL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm92097500",
                            "field1": "Vitakraft",
                            "field2": "ciotola in plastica doppia",
                            "field3": "per cani e gatti",
                            "field4": "",
                            "description": "Vitakraft ciotola in plastica doppia per cani e gatti",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Care",
                            "blueprint": {
                                "top": 73.88059559153086,
                                "left": 50.16519413421403,
                                "width": 23.90556070460609,
                                "height": 21.019888635891586
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_eVaeZcb_PMf7dN0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm77344213",
                            "field1": "Morando miglior gatto",
                            "field2": "straccetti vari gusti",
                            "field3": "gr.100",
                            "field4": "",
                            "description": "Morando miglior gatto straccetti vari gusti gr.100",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 3,
                            "quantity_step": 3,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 73.88059559153086,
                                "left": 26.019347053262134,
                                "width": 24.145847080951903,
                                "height": 21.019888635891586
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_sLro62c_nB4tk76.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm00047282",
                            "field1": "Morando miglior cane",
                            "field2": "vitello e carote/ coniglio e pollo/",
                            "field3": "trippa e agnello",
                            "field4": "gr.300",
                            "description": "Morando miglior cane vitello e carote/ coniglio e pollo/ trippa e agnello gr.300",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Vitello e carote",
                                "Coniglio e pollo",
                                "Trippa e agnello"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Pet",
                            "subcategory": "Food",
                            "blueprint": {
                                "top": 73.88059559153086,
                                "left": 3.1949403155502427,
                                "width": 22.82440673771189,
                                "height": 21.019888635891586
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_TuSK8tg_Tsm7PUi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 27,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_27_TAlFXm7.jpg",
                    "products": [
                        {
                            "item_id": "cstm58242066",
                            "field1": "Carrefour",
                            "field2": "Panbauletto farro",
                            "field3": "bio gr 400",
                            "field4": "",
                            "description": "Carrefour Panbauletto farro bio gr 400",
                            "grammage": null,
                            "price": "2.19",
                            "price_label": "€ 2,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 8.90520623004189,
                                "left": 2.963917525773196,
                                "width": 31.57216494845361,
                                "height": 22.015068091048988
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_WWzHNru_D9I6qEX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm70009566",
                            "field1": "Carrefour",
                            "field2": "Pane kamut bio",
                            "field3": "gr 400",
                            "field4": "",
                            "description": "Carrefour Pane kamut bio gr 400",
                            "grammage": null,
                            "price": "2.19",
                            "price_label": "€ 2,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 8.90520623004189,
                                "left": 34.5360824742268,
                                "width": 30.927835051546396,
                                "height": 22.015068091048988
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_E3EOu48_ZLwybZr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm23520829",
                            "field1": "Carrefour",
                            "field2": "Pomodori perlati",
                            "field3": "bio gr 400",
                            "field4": "",
                            "description": "Carrefour Pomodori perlati bio gr 400",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 9.572329505528222,
                                "left": 65.59278350515464,
                                "width": 30.927835051546396,
                                "height": 20.28054757478452
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_GRg5t9P_1h0scag.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm84148466",
                            "field1": "Carrefour",
                            "field2": "Froll fiocchi di farro",
                            "field3": "bio gr 300",
                            "field4": "",
                            "description": "Carrefour Froll fiocchi di farro bio gr 300",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 29.852877080312744,
                                "left": 65.59278350515464,
                                "width": 30.927835051546396,
                                "height": 22.28191740124352
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_6vtWmQZ_32PRVqI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm10627642",
                            "field1": "Carrefour",
                            "field2": "Gallette bio di mais/ di riso",
                            "field3": "gr 120",
                            "field4": "",
                            "description": "Carrefour Gallette bio di mais/ di riso gr 120",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Di mais",
                                "Di riso"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.786849665993607,
                                "left": 34.27835051546392,
                                "width": 31.314432989690722,
                                "height": 21.347944815562652
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_qu0RS1s_3Ba6xKO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm30805640",
                            "field1": "Carrefour",
                            "field2": "Piadina fresca integrale bio",
                            "field3": "gr 225",
                            "field4": "",
                            "description": "Carrefour Piadina fresca integrale bio gr 225",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 30.786849665993607,
                                "left": 0.9020618556701032,
                                "width": 33.37628865979382,
                                "height": 21.347944815562652
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_hymej0h_AJCzPGv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm66657125",
                            "field1": "Carrefour",
                            "field2": "Succo bio mela e carota",
                            "field3": "ml 500",
                            "field4": "",
                            "description": "Carrefour Succo bio mela e carota ml 500",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Succhi",
                            "blueprint": {
                                "top": 52.13479448155626,
                                "left": 0.9020618556701032,
                                "width": 33.37628865979382,
                                "height": 21.61479412575719
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ZDPAAgt_twDPZKD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm28864343",
                            "field1": "Carrefour",
                            "field2": "Yogurt vegetale soysi",
                            "field3": "vari gusti",
                            "field4": "gr 125x2",
                            "description": "Carrefour Yogurt vegetale soysi vari gusti gr 125x2",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 52.13479448155626,
                                "left": 34.27835051546392,
                                "width": 30.927835051546396,
                                "height": 21.61479412575719
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Ojlgteo_bqH5q9M.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm86880874",
                            "field1": "Carrefour",
                            "field2": "Fagiolini finissimi",
                            "field3": "bio gr 450",
                            "field4": "",
                            "description": "Carrefour Fagiolini finissimi bio gr 450",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 52.13479448155626,
                                "left": 65.20618556701031,
                                "width": 30.541237113402065,
                                "height": 21.61479412575719
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_slk2cNg_24jnCma.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 28,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_28_5fd018Q.jpg",
                    "products": [
                        {
                            "item_id": "cstm80520629",
                            "field1": "Sole",
                            "field2": "Detersivo lavatrice",
                            "field3": "lana e delicati/ Tutti i colori delicati/ Nero vivace/ talco",
                            "field4": "lt 1",
                            "description": "Sole Detersivo lavatrice lana e delicati/ Tutti i colori delicati/ Nero vivace/ talco lt 1",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Lana e delicati",
                                "Tutti i colori delicati",
                                "Nero vivace",
                                "Talco"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 9.172055540236423,
                                "left": 3.3505154639175263,
                                "width": 22.93814432989691,
                                "height": 21.61479412575719
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_JGMcjT0_LM1jA5S.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm65526324",
                            "field1": "Sole",
                            "field2": "Detersivo lavatrice in polvere",
                            "field3": "fustone bianco splendente con bicarbonato 92 misurini",
                            "field4": "",
                            "description": "Sole Detersivo lavatrice in polvere fustone bianco splendente con bicarbonato 92 misurini",
                            "grammage": null,
                            "price": "8.49",
                            "price_label": "€ 8,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 9.172055540236423,
                                "left": 26.28865979381444,
                                "width": 23.453608247422682,
                                "height": 21.61479412575719
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ZDE87ne_yrWMQ0j.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm00524913",
                            "field1": "Soft",
                            "field2": "Detersivo per lavatrice vari tipi",
                            "field3": "32 lavaggi ",
                            "field4": "lt 2,5",
                            "description": "Soft Detersivo per lavatrice vari tipi 32 lavaggi  lt 2,5",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 30.786849665993607,
                                "left": 2.577319587628866,
                                "width": 23.711340206185568,
                                "height": 21.081095505368122
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Nd3bZ7m_yk3pnlp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99016775",
                            "field1": "Soft",
                            "field2": "Ammorbidente",
                            "field3": "varie profumazioni 50 lavaggi",
                            "field4": "lt 3",
                            "description": "Soft Ammorbidente varie profumazioni 50 lavaggi lt 3",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 30.786849665993607,
                                "left": 26.28865979381444,
                                "width": 23.582474226804123,
                                "height": 21.081095505368122
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_CbauyTk_ngOoBYS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm37244682",
                            "field1": "Bio presto",
                            "field2": "Detersivo lavatrice",
                            "field3": "liquido vari tipi 36 lavaggi",
                            "field4": "lt 1,8",
                            "description": "Bio presto Detersivo lavatrice liquido vari tipi 36 lavaggi lt 1,8",
                            "grammage": null,
                            "price": "2.89",
                            "price_label": "€ 2,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 10.773151401403622,
                                "left": 49.87113402061856,
                                "width": 23.45360824742269,
                                "height": 41.0947937699581
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_GSryzaU_SzrzrCS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/BioPresto.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm01693639",
                            "field1": "Lenor ",
                            "field2": "Ammorbidente concentrato",
                            "field3": "varie profumazioni 74 lavaggi",
                            "field4": "lt 1,85/80 lavaggi lt 2",
                            "description": "Lenor  Ammorbidente concentrato varie profumazioni 74 lavaggi lt 1,85/80 lavaggi lt 2",
                            "grammage": null,
                            "price": "3.49",
                            "price_label": "€ 3,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 9.038630885139156,
                                "left": 73.32474226804123,
                                "width": 22.9381443298969,
                                "height": 42.829314286222576
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_grite42_b0MMuGO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm80967914",
                            "field1": "Napisan",
                            "field2": "Polvere gr 600/ liquido classico/ profumo di primavera",
                            "field3": "lt 1,2",
                            "field4": "",
                            "description": "Napisan Polvere gr 600/ liquido classico/ profumo di primavera lt 1,2",
                            "grammage": null,
                            "price": "3.29",
                            "price_label": "€ 3,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Polvere",
                                "Liquido classico",
                                "Profumo di primavera"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 51.86794517136173,
                                "left": 73.58247422680412,
                                "width": 23.067010309278345,
                                "height": 22.015068091048988
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_lIPSI31_JyTCotN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm79950483",
                            "field1": "Lysoform",
                            "field2": "Candeggina Classica/ Floreale/ Freschezza alpina",
                            "field3": "lt 2,5",
                            "field4": "",
                            "description": "Lysoform Candeggina Classica/ Floreale/ Freschezza alpina lt 2,5",
                            "grammage": null,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classica",
                                "Floreale",
                                "Freschezza alpina"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 51.86794517136173,
                                "left": 50.25773195876288,
                                "width": 23.32474226804125,
                                "height": 22.015068091048988
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_P59QOex_vMyq3fK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm75283512",
                            "field1": "Lysoform",
                            "field2": "Igienizzante lavatrice",
                            "field3": "x32 caps",
                            "field4": "",
                            "description": "Lysoform Igienizzante lavatrice x32 caps",
                            "grammage": null,
                            "price": "6.79",
                            "price_label": "€ 6,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 51.86794517136173,
                                "left": 3.737113402061871,
                                "width": 46.52061855670102,
                                "height": 22.015068091048988
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_GfYTqEA_PwbcIWi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17188911",
                            "field1": "Finish",
                            "field2": "Powerball al in 1",
                            "field3": "max 94 tabs limone",
                            "field4": "",
                            "description": "Finish Powerball al in 1 max 94 tabs limone",
                            "grammage": null,
                            "price": "8.99",
                            "price_label": "€ 8,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Stoviglie",
                            "blueprint": {
                                "top": 73.88301326241071,
                                "left": 3.737113402061871,
                                "width": 46.52061855670102,
                                "height": 21.214520160465387
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_mWySLVN_TdQR0fo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Finish_Quantum_Ultimate.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm84087639",
                            "field1": "Cif",
                            "field2": "Duo spray",
                            "field3": "vari tipi",
                            "field4": "ml 650",
                            "description": "Cif Duo spray vari tipi ml 650",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 73.88301326241071,
                                "left": 50.25773195876289,
                                "width": 23.195876288659807,
                                "height": 21.214520160465387
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_4rDanp4_Wo93Boa.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm45553243",
                            "field1": "Smac",
                            "field2": "Acciaio",
                            "field3": "crema/spray",
                            "field4": "ml 500",
                            "description": "Smac Acciaio crema/spray ml 500",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Crema",
                                "Spray"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 73.88301326241071,
                                "left": 73.45360824742271,
                                "width": 23.32474226804123,
                                "height": 21.214520160465387
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_eHQtgwR_r1QXoC4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 29,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_29_pcpcy7i.jpg",
                    "products": [
                        {
                            "item_id": "cstm67261379",
                            "field1": "Svelto",
                            "field2": "Detergente stoviglie aceto /limone",
                            "field3": "1000x4",
                            "field4": "",
                            "description": "Svelto Detergente stoviglie aceto /limone 1000x4",
                            "grammage": null,
                            "price": "3.89",
                            "price_label": "€ 3,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Aceto",
                                "Limone"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 9.038630885139156,
                                "left": 3.4793814432989687,
                                "width": 22.422680412371136,
                                "height": 21.74821878085445
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_bSQjZPl_EPu6fRE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51025683",
                            "field1": "WC net",
                            "field2": "Candeggina gel/ Disincrostante/ Profumoso/",
                            "field3": "Igiene totale/ Bio igiene ml 700/ Mousse candeggina ml 600",
                            "field4": "",
                            "description": "WC net Candeggina gel/ Disincrostante/ Profumoso/ Igiene totale/ Bio igiene ml 700/ Mousse candeggina ml 600",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Candeggina gel",
                                "Disincrostante",
                                "Profumoso",
                                "Igiene totale",
                                "Bio igiene",
                                "Mousse candeggina"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 9.038630885139156,
                                "left": 26.54639175257732,
                                "width": 23.324742268041234,
                                "height": 21.74821878085445
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_r9CVN0u_Fjc6czg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm09209057",
                            "field1": "Scottex",
                            "field2": "120 tovaglioli festa",
                            "field3": "",
                            "field4": "",
                            "description": "Scottex 120 tovaglioli festa",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 30.786849665993607,
                                "left": 26.54639175257732,
                                "width": 23.324742268041238,
                                "height": 21.48136947065992
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_EQ55Ppo_Tost87f.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm77979094",
                            "field1": "Regina di cuori",
                            "field2": "Asciugatutto",
                            "field3": "3 rotoli",
                            "field4": "",
                            "description": "Regina di cuori Asciugatutto 3 rotoli",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 30.786849665993607,
                                "left": 0.0,
                                "width": 26.54639175257732,
                                "height": 21.48136947065992
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_1v6Hbua_2zlW5aK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm79700618",
                            "field1": "ACE",
                            "field2": "Detersivo pavimenti igienizzante talco/ lavanda/ sto germs",
                            "field3": "lt 1x2",
                            "field4": "",
                            "description": "ACE Detersivo pavimenti igienizzante talco/ lavanda/ sto germs lt 1x2",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Talco",
                                "Lavanda",
                                "Sto germs"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Pavimenti",
                            "blueprint": {
                                "top": 9.438904850430957,
                                "left": 50.12886597938145,
                                "width": 26.54639175257732,
                                "height": 42.56246497602804
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_BfdXEuI_lfplqIH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm57789384",
                            "field1": "Bioform",
                            "field2": "Plus disinfettante/ spray igienizzante ",
                            "field3": "vari tipi",
                            "field4": "ml 750",
                            "description": "Bioform Plus disinfettante/ spray igienizzante  vari tipi ml 750",
                            "grammage": null,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Plus disinfettante",
                                "Spray igienizzante"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 9.438904850430957,
                                "left": 76.67525773195877,
                                "width": 23.324742268041234,
                                "height": 42.56246497602804
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_KMa2oO6_7iWL7vY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm35257053",
                            "field1": "VET",
                            "field2": "Unica ",
                            "field3": "carta igienica doppio velo",
                            "field4": "4 rotoli",
                            "description": "VET Unica  carta igienica doppio velo 4 rotoli",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 52.268219136653535,
                                "left": 50.0,
                                "width": 23.324742268041238,
                                "height": 21.347944815562652
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_saLdzsN_jT4oQVI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm85004138",
                            "field1": "Foxy",
                            "field2": "Mega carta igienica",
                            "field3": "12 rotoloni",
                            "field4": "",
                            "description": "Foxy Mega carta igienica 12 rotoloni",
                            "grammage": null,
                            "price": "5.29",
                            "price_label": "€ 5,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 55.737260169182456,
                                "left": 3.221649484536075,
                                "width": 23.324742268041238,
                                "height": 39.49369790879091
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_H8YABCR_33JesHB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm73746192",
                            "field1": "Head & shoulders",
                            "field2": "Shampoo ml 225/250/ Balsamo ml 220",
                            "field3": "vari tipi",
                            "field4": "",
                            "description": "Head & shoulders Shampoo ml 225/250/ Balsamo ml 220 vari tipi",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Shampoo",
                                "Balsamo"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Capelli",
                            "blueprint": {
                                "top": 52.66849310194533,
                                "left": 26.546391752577318,
                                "width": 23.195876288659797,
                                "height": 42.56246497602804
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_mezZAUS_M4uuqAh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm76297517",
                            "field1": "Bio less",
                            "field2": "Piatti piani/ fondi compostabili x24/ bicchieri compostabili ",
                            "field3": "cc 200x50",
                            "field4": "",
                            "description": "Bio less Piatti piani/ fondi compostabili x24/ bicchieri compostabili  cc 200x50",
                            "grammage": null,
                            "price": "0.00",
                            "price_label": "SCONTO DEL 10% ALLE CASSE",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Piatti piani",
                                "Fondi compostabili",
                                "Bicchieri compostabili"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Stoviglie",
                            "blueprint": {
                                "top": 52.40164379175079,
                                "left": 73.84020618556701,
                                "width": 23.067010309278356,
                                "height": 21.48136947065992
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_fSHfT2h_Ailiobp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm13214017",
                            "field1": "Zanzir",
                            "field2": "Citronella ",
                            "field3": "vari tipi",
                            "field4": "",
                            "description": "Zanzir Citronella  vari tipi",
                            "grammage": null,
                            "price": "0.00",
                            "price_label": "SCONTO DEL 15% ALLE CASSE",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Giardino e Giardinaggio",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 73.88301326241071,
                                "left": 73.84020618556701,
                                "width": 23.067010309278356,
                                "height": 20.947670850270853
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_BlMGUsl_6fqQMpP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm22106434",
                            "field1": "Raid ",
                            "field2": "insetticida mosche e zanzare ml 400/ Liquido base/ ricarica 30 notti",
                            "field3": "",
                            "field4": "",
                            "description": "Raid  insetticida mosche e zanzare ml 400/ Liquido base/ ricarica 30 notti",
                            "grammage": null,
                            "price": "0.00",
                            "price_label": "SCONTO DEL 15% ALLE CASSE",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Insetticida mosche e zanzare",
                                "Liquido base",
                                "Ricarica 30 notti"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 73.88301326241071,
                                "left": 50.38659793814434,
                                "width": 23.45360824742268,
                                "height": 20.947670850270853
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_VyyvesG_TQKQAGR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 30,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_30_ZXQrM1Y.jpg",
                    "products": [
                        {
                            "item_id": "cstm11067409",
                            "field1": "L'oreal excellence",
                            "field2": "vari colori",
                            "field3": "",
                            "field4": "",
                            "description": "L'oreal excellence vari colori",
                            "grammage": null,
                            "price": "6.99",
                            "price_label": "€ 6,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Capelli",
                            "blueprint": {
                                "top": 9.172055540236423,
                                "left": 19.45876288659794,
                                "width": 16.62371134020618,
                                "height": 20.814246195173588
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_yFxfqYO_3PmmLVI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm64202566",
                            "field1": "Grafic",
                            "field2": "Lacca fissante extra forte ml 250/Mousse mega volume/Onde & Ricci ml 150/Gel mega fix Extra forte ml 150 + 50 omaggio/Acqua gel ml 200",
                            "field3": "",
                            "field4": "",
                            "description": "Grafic Lacca fissante extra forte ml 250/Mousse mega volume/Onde & Ricci ml 150/Gel mega fix Extra forte ml 150 + 50 omaggio/Acqua gel ml 200",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Lacca fissante extra forte",
                                "Mousse mega volume",
                                "Onde & Ricci",
                                "Gel mega fix Extra forte",
                                "Acqua gel"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Capelli",
                            "blueprint": {
                                "top": 9.172055540236423,
                                "left": 36.08247422680413,
                                "width": 13.659793814432993,
                                "height": 20.814246195173588
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_TmfCHlG_JOad0HI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm66660935",
                            "field1": "L'oreal",
                            "field2": "Dermo expertise revitalif giorno/Crema antirughe notte",
                            "field3": "ml 50",
                            "field4": "",
                            "description": "L'oreal Dermo expertise revitalif giorno/Crema antirughe notte ml 50",
                            "grammage": null,
                            "price": "7.99",
                            "price_label": "€ 7,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Dermo expertise revitalif giorno",
                                "Crema antirughe notte"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Viso",
                            "blueprint": {
                                "top": 30.786849665993607,
                                "left": 33.76288659793815,
                                "width": 15.979381443298974,
                                "height": 21.347944815562652
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_1CCfvyL_yjqcCX8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm54517862",
                            "field1": "Gillette blue3",
                            "field2": "4 rasoi usa e getta classici +2 gratis/sensitive +1 gratis",
                            "field3": "",
                            "field4": "",
                            "description": "Gillette blue3 4 rasoi usa e getta classici +2 gratis/sensitive +1 gratis",
                            "grammage": null,
                            "price": "3.29",
                            "price_label": "€ 3,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classico",
                                "Sensitive"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Viso",
                            "blueprint": {
                                "top": 30.786849665993607,
                                "left": 17.52577319587629,
                                "width": 16.237113402061855,
                                "height": 21.347944815562652
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Ux9qCXd_IsngekM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm64766995",
                            "field1": "Gillette",
                            "field2": "Series gel barba idratante/Pelli sensibili/Sensitive cool/Mach3 gel extra confort",
                            "field3": "ml 200",
                            "field4": "",
                            "description": "Gillette Series gel barba idratante/Pelli sensibili/Sensitive cool/Mach3 gel extra confort ml 200",
                            "grammage": null,
                            "price": "2.69",
                            "price_label": "€ 2,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Gel barba idratante",
                                "Pelli sensibili",
                                "Sensitive cool",
                                "Mach3 gel extra confort"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Viso",
                            "blueprint": {
                                "top": 30.786849665993607,
                                "left": 2.9639175257731925,
                                "width": 14.561855670103098,
                                "height": 21.347944815562652
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_gQMi2F4_Q9HDQFP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm91631859",
                            "field1": "Iodosan",
                            "field2": "Dentifricio buova formula",
                            "field3": "protezione globale",
                            "field4": "ml 75",
                            "description": "Iodosan Dentifricio buova formula protezione globale ml 75",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Orale",
                            "blueprint": {
                                "top": 31.053698976188144,
                                "left": 50.12886597938145,
                                "width": 19.07216494845361,
                                "height": 21.347944815562652
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_KmIZxNv_4zONp24.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm89259641",
                            "field1": "Sensodine",
                            "field2": "Dentifricio",
                            "field3": "Vari tipi",
                            "field4": "ml 75",
                            "description": "Sensodine Dentifricio Vari tipi ml 75",
                            "grammage": null,
                            "price": "3.49",
                            "price_label": "€ 3,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Orale",
                            "blueprint": {
                                "top": 42.37210503852781,
                                "left": 69.20103092783505,
                                "width": 26.41963339539169,
                                "height": 10.029538753222985
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_5wOsqD2_D2xtZ9r.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm46645483",
                            "field1": "Paradontax",
                            "field2": "Dentifricio",
                            "field3": "vari tipi",
                            "field4": "ml 75",
                            "description": "Paradontax Dentifricio vari tipi ml 75",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Orale",
                            "blueprint": {
                                "top": 31.053698976188144,
                                "left": 69.25789697440388,
                                "width": 26.618391685389977,
                                "height": 11.646452278249223
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_MJSXF5E_C7iEw7G.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.parodontax.it/prodotti/dentifricio-parodontax/?gclid=Cj0KCQjwh_eFBhDZARIsALHjIKcuvZbg_GKU7UBgyOkLB12AHdsIVpEO1g9BEZbvbIki8REvi_hiCt0aAuApEALw_wcB&gclsrc=aw.ds"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm09541041",
                            "field1": "Leocrema",
                            "field2": "Crema viso",
                            "field3": "natural idratante/purificante",
                            "field4": "ml 7,5x2",
                            "description": "Leocrema Crema viso natural idratante/purificante ml 7,5x2",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Idratante",
                                "Purificante"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 75.88438308886973,
                                "left": 3.737113402061856,
                                "width": 20.2319587628866,
                                "height": 6.0041094793769965
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_JA2uDcU_FTiifJM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm72028754",
                            "field1": "Leocrema",
                            "field2": "Pellefresca/ Pellemorbida",
                            "field3": "ml 150",
                            "field4": "",
                            "description": "Leocrema Pellefresca/ Pellemorbida ml 150",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Pellefresca",
                                "Pellemorbida"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Orale",
                            "blueprint": {
                                "top": 81.88849256824672,
                                "left": 3.737113402061856,
                                "width": 20.2319587628866,
                                "height": 4.8032875835015965
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_gLO3gKm_2fSzxHO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99348301",
                            "field1": "Leocrema",
                            "field2": "Fluida vari tipi",
                            "field3": "ml 400",
                            "field4": "",
                            "description": "Leocrema Fluida vari tipi ml 400",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 87.56931410832304,
                                "left": 3.9948453608247427,
                                "width": 16.861597938144328,
                                "height": 5.049589496811148
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_O9b8JuV_E2s8tB1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm70352606",
                            "field1": "Felce azzurra",
                            "field2": "Detergente intimo delicato/dolce",
                            "field3": "protezione",
                            "field4": "ml 250",
                            "description": "Felce azzurra Detergente intimo delicato/dolce protezione ml 250",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Delicato",
                                "Dolce"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 73.95999928840185,
                                "left": 40.057474226804125,
                                "width": 16.901288659793813,
                                "height": 19.726301557510475
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_xRPVXsA_0EjvUfx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm83006238",
                            "field1": "Nidra ",
                            "field2": "Bagnoschiuma latte/mandorla",
                            "field3": "argan",
                            "field4": "ml 750",
                            "description": "Nidra  Bagnoschiuma latte/mandorla argan ml 750",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Latte",
                                "Mandorla"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 8.771781574944622,
                                "left": 0.0,
                                "width": 19.716494845360828,
                                "height": 22.14849274614625
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_QJ5aL2B_wlkjQQk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm77525544",
                            "field1": "Laurella",
                            "field2": "Ultra assorbenti",
                            "field3": "vari tipi",
                            "field4": "",
                            "description": "Laurella Ultra assorbenti vari tipi",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 73.74958860731347,
                                "left": 57.08762886597938,
                                "width": 19.974226804123713,
                                "height": 21.48136947065992
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ibQO4Sw_XVlpRc3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm50117916",
                            "field1": "Lines seta ultra",
                            "field2": "Assorbenti",
                            "field3": "Vari tipi",
                            "field4": "",
                            "description": "Lines seta ultra Assorbenti Vari tipi",
                            "grammage": null,
                            "price": "2.00",
                            "price_label": "€ 2,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 73.74958860731347,
                                "left": 77.0618556701031,
                                "width": 22.93814432989691,
                                "height": 21.48136947065992
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_2YRoaEH_mvP3Jea.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/video/Lines_Seta_Ultra.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm12043850",
                            "field1": "Felce azzurra",
                            "field2": "Sapone liquido classico/ antibatterico",
                            "field3": "dispenser",
                            "field4": "ml 300",
                            "description": "Felce azzurra Sapone liquido classico/ antibatterico dispenser ml 300",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classico",
                                "Antibatterico"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 52.268219136653535,
                                "left": 40.07731958762887,
                                "width": 20.489690721649488,
                                "height": 21.74821878085445
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_YeUgTmE_LRoRB79.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 31,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_31_6IwB6EI.jpg",
                    "products": [
                        {
                            "item_id": "cstm77006708",
                            "field1": "Gio'style",
                            "field2": "Set 2 borse frigo",
                            "field3": "termiche fiesta",
                            "field4": "lt 24+7",
                            "description": "Gio'style Set 2 borse frigo termiche fiesta lt 24+7",
                            "grammage": null,
                            "price": "5.99",
                            "price_label": "€ 5,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 9.515890876422077,
                                "left": 3.0927835051546393,
                                "width": 23.176030927835047,
                                "height": 21.060548108483136
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_3bUHdQ4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm21076670",
                            "field1": "Coveri",
                            "field2": "Borsa frigo cilindro",
                            "field3": "PVC 3mm 5 colori",
                            "field4": "assortiti",
                            "description": "Coveri Borsa frigo cilindro PVC 3mm 5 colori assortiti",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 9.515890876422077,
                                "left": 26.268814432989686,
                                "width": 23.860051546391762,
                                "height": 21.060548108483136
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_hyrSkzX_ghjY7l2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm61424705",
                            "field1": "Ombrellone Oxford",
                            "field2": "Vietri dm 200",
                            "field3": "32 stecche in acciaio",
                            "field4": "con sacca in tessuto",
                            "description": "Ombrellone Oxford Vietri dm 200 32 stecche in acciaio con sacca in tessuto",
                            "grammage": null,
                            "price": "11.99",
                            "price_label": "€ 11,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 9.515890876422077,
                                "left": 50.12886597938145,
                                "width": 46.75850515463917,
                                "height": 21.19397276358041
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_miY3UZH_gilt2wd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm16243825",
                            "field1": "Ombrellone Oxford",
                            "field2": "Vietri dm 180",
                            "field3": "32 stecche in acciaio",
                            "field4": "con sacca in tessuto",
                            "description": "Ombrellone Oxford Vietri dm 180 32 stecche in acciaio con sacca in tessuto",
                            "grammage": null,
                            "price": "9.99",
                            "price_label": "€ 9,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 30.709863640002485,
                                "left": 50.12886597938145,
                                "width": 46.75850515463917,
                                "height": 20.834793592058567
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_BdRZsn0_isozhtp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88521435",
                            "field1": "Rodi",
                            "field2": "Sdraio carrello tubo ottagonale 35x20",
                            "field3": "Cuscino cm 7",
                            "field4": "",
                            "description": "Rodi Sdraio carrello tubo ottagonale 35x20 Cuscino cm 7",
                            "grammage": null,
                            "price": "59.99",
                            "price_label": "€ 59,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 30.709863640002485,
                                "left": 3.2018041237113257,
                                "width": 46.92706185567012,
                                "height": 20.834793592058567
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_url49Hn_TbKksaZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm15258208",
                            "field1": "Giostyle",
                            "field2": "Piastra ghiaccio",
                            "field3": "2x400",
                            "field4": "",
                            "description": "Giostyle Piastra ghiaccio 2x400",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 51.544657232061056,
                                "left": 3.2018041237113257,
                                "width": 19.60747422680414,
                                "height": 22.528219314553073
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_4X7QqCR_VGlm3DK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm45964618",
                            "field1": "Piscina summer",
                            "field2": "a 3 anelli color ",
                            "field3": "con fondo",
                            "field4": "",
                            "description": "Piscina summer a 3 anelli color  con fondo",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 51.544657232061056,
                                "left": 22.809278350515466,
                                "width": 32.712113402061846,
                                "height": 22.528219314553073
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_ioDsFGq_9fs1Gm5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm76605243",
                            "field1": "Pompa manuale",
                            "field2": "cm 30",
                            "field3": "Volume 850 cc",
                            "field4": "",
                            "description": "Pompa manuale cm 30 Volume 850 cc",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 51.41123257696378,
                                "left": 55.521391752577316,
                                "width": 21.025000000000016,
                                "height": 22.66164396965034
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_Ibxa51p_rGAlcWI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm17573780",
                            "field1": "Set fundive",
                            "field2": "snorkel",
                            "field3": "3-6 anni",
                            "field4": "",
                            "description": "Set fundive snorkel 3-6 anni",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Sport e Tempo Libero",
                            "subcategory": "Camping e Outdoor",
                            "blueprint": {
                                "top": 51.41123257696378,
                                "left": 76.54639175257734,
                                "width": 22.422680412371136,
                                "height": 22.66164396965034
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_31htSnK_0QWqSlo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm74399600",
                            "field1": "Luna rosa",
                            "field2": "Servizio da tavola",
                            "field3": "19 pezzi",
                            "field4": "",
                            "description": "Luna rosa Servizio da tavola 19 pezzi",
                            "grammage": null,
                            "price": "19.99",
                            "price_label": "€ 19,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Casa e Cucina",
                            "subcategory": "Stoviglie",
                            "blueprint": {
                                "top": 73.48273929711893,
                                "left": 2.963917525773196,
                                "width": 23.582474226804123,
                                "height": 22.548766711438052
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/products/cropped_image_UisdIGp_xeUI04K.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 32,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/page_32_pHuiC10.jpg",
                    "products": []
                },
                {
                    "number": 33,
                    "image_file": "https://interattivo.s3.amazonaws.com/4cxvYv8pS1/pages/Fine-Carrefou_HKPMz3R.png",
                    "products": []
                }
            ]
        }
    }

}

const lefletSwitch = () => {
    return leaflets.apulia;
}

export const serverResponse = lefletSwitch(); 